import { Backdrop, Button, CircularProgress, DialogActions, MenuItem, Select } from '@mui/material';
import { MapContext, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from "highcharts/highcharts-more";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeederStatus } from '../../features/geoJson/feedersStatus';
import { updateColor } from "../../features/powerComplaints/colorSlice";
import alert from '../../images/Alert.png';
import blueCircle from '../../images/blueCircle.png';
import orangeCircle from '../../images/orange_Circle.png';
import InfoImage from "../../images/informationButton.png";
import poweron from '../../images/poweron.png';
import redGif from '../../images/red.gif';
import redCircle from '../../images/red_circle.png';
import triangleoff from '../../images/triangle-off.png';
import triangleon from '../../images/triangle-on.png';
import feild from '../../images/field.png';
import offline from '../../images/offline.png';

import { convertDatewithTime, getGoogleMapsApiKey, formatDate, subdivisionName } from '../../services/Functions';
import './map.scss';
import { fetchGeoJson } from '../../features/geoJson/geoJson';

HighchartsMore(Highcharts);

// Module-level cache: map instance persists across component mounts (saves API loads)
let cachedMapInstance = null;
let cachedMapDiv = null;
// Module-level arrays to track markers that need clearing on remount
let cachedFieldStaffMarkers = [];
let cachedComplaintMarkers = [];
let cachedHeatmapLayer = null;
let cachedHeatmapInterval = null;
let cachedWeatherOverlays = [];

const containerStyle = {
    width: '100%',
    height: '100%'
};

const mapLibraries = ['visualization'];

function Map({ connections, fieldStaff, complaints, handleSubmit, onComplaintsUpdate, selectedMarker1, updateSelectedMarker1, company, setCode, setDivision, setSubDivision, hierarchyCode, circleCode, divisionCode, weatherData, parentData }) {
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const { color } = useSelector((state) => state.feederColor);
    const { home: homeButtonState } = useSelector(state => state.homeButton);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const { code, hierarchy, token, permissions, name, roleName, userId, circleCode: CircleCode, roleTypeId } = useSelector((state) => state.auth);
    const { data: geoJSON } = useSelector((state) => state.geoJson);
    const { data: divisionGeoJson } = useSelector((state) => state.divisionGeoJson);
    const { officeCode } = useSelector(state => state.officeCode);

    const [map, setMap] = useState(null);
    const [markers, setMarkers] = useState([]);
    const [apmsMarkers, setApmsMarkers] = useState([]);
    const [selectedMarker, setSelectedMarker] = useState();
    const [avgLat, setAvgLat] = useState();
    const [avgLng, setAvgLng] = useState();
    const [flash, setFlash] = useState(true);
    const [center, setCenter] = useState({
        lat: avgLat,
        lng: avgLng
    });
    const [feederInfo, setFeederInfo] = useState([]);
    const [verificationPopup, setVerificationPopup] = useState(false);
    const [verificationPopup1, setVerificationPopup1] = useState(false);
    const [data1, setData1] = useState();
    const [showFeedbackDropdown, setShowFeedbackDropdown] = useState(false);
    const [reason, setReason] = useState("1");
    const [isBoundsSet, setIsBoundsSet] = useState();
    const [displayMode, setDisplayMode] = useState('lineman'); // Toggle: 'lineman' | 'complaints' | 'both' | 'heatmap' | 'weather'
    const [selectedDesignationFilter, setSelectedDesignationFilter] = useState('all'); // 'all' or specific designation like 'ALM', 'LM-I', etc.
    const [complaintMarkers, setComplaintMarkers] = useState([]); // Track complaint markers for clearing
    const heatmapLayerRef = useRef(null);
    const heatmapBlinkRef = useRef(null);
    const weatherOverlaysRef = useRef([]);
    const displayModeRef = useRef(displayMode);
    const mapContainerRef = useRef(null);


    const [loadOption, setLoadOption] = useState({
        chart: {
            type: 'gauge',
            height: '100%',
            backgroundColor: 'transparent',
            width: null,
        },
        title: {
            text: 'Load (kVA)',
            style: {
                fontSize: '15px'
            }
        },
        legend: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        pane: {
            startAngle: -90,
            endAngle: 89.9,
            background: null,
            center: ['50%', '75%'],
            size: '110%'
        },
        yAxis: {
            min: 0,
            max: 100,
            tickPixelInterval: 72,
            tickPosition: 'inside',
            tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
            tickLength: 10,
            tickWidth: 2,
            minorTickInterval: null,
            labels: {
                distance: -25,
                enabled: false
            },
            lineWidth: 0,
            plotBands: [{
                from: 0,
                to: 25,
                color: '#05b129',
                thickness: 30,
                label: {
                    text: 'Low',
                    align: 'center',
                    style: {
                        color: '#FFFFFF',
                        fontSize: '10px',
                        fontWeight: 'bold'
                    },
                    x: 30,
                    y: 20,
                    rotation: 0
                }
            }, {
                from: 25,
                to: 50,
                color: '#55BF3B',
                thickness: 30,
                label: {
                    text: 'Medium',
                    align: 'center',
                    style: {
                        color: '#FFFFFF',
                        fontSize: '10px',
                        fontWeight: 'bold'
                    },
                    x: 40,
                    y: 30,
                    rotation: 0
                }
            }, {
                from: 50,
                to: 75,
                color: '#f69d26',
                thickness: 30,
                label: {
                    text: 'High',
                    align: 'center',
                    style: {
                        color: '#FFFFFF',
                        fontSize: '10px',
                        fontWeight: 'bold'
                    },
                    x: -30,
                    y: 30,
                    rotation: 0
                }
            }, {
                from: 75,
                to: 100,
                color: '#ef4b31',
                thickness: 30,
                label: {
                    text: 'Max',
                    align: 'center',
                    style: {
                        color: '#FF0000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    },
                    x: -30,
                    y: 20,
                    rotation: 0
                }
            }]
        },
        series: [{
            name: 'Load',
            tooltip: {
                valueSuffix: ''
            },
            dataLabels: {
                enabled: false,
                format: '{y}',
                borderWidth: 0,
                color: (
                    Highcharts.defaultOptions.title &&
                    Highcharts.defaultOptions.title.style &&
                    Highcharts.defaultOptions.title.style.color
                ) || '#333333',
                style: {
                    fontSize: '16px'
                }
            },
            dial: {
                radius: '80%',
                backgroundColor: 'gray',
                baseWidth: 12,
                baseLength: '0%',
                rearLength: '0%'
            },
            pivot: {
                backgroundColor: 'gray',
                radius: 6
            }
        }]
    });

    const [voltageOptions, setVoltageOptions] = useState({
        chart: {
            type: 'bar',
            height: 150,
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Voltage',
            style: {
                fontSize: '15px',
                margin: 0
            }
        },
        xAxis: {
            categories: ['Va', 'Vb', 'Vc'],
        },
        legend: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        plotOptions: {
            series: {
                pointWidth: 15,
                pointPadding: 0.05,
                groupPadding: 0.1,
            },
        },
        series: [
            {
                name: 'Voltage',
                data: [232, 229, 229],
                colorByPoint: true,
                colors: ['#E46E6E', '#E4D354', '#7CB5EC'],
            },
        ],
    });

    const [currentOptions, setCurrentOptions] = useState({
        chart: {
            type: 'bar',
            height: 150,
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Current (Amp)',
            style: {
                fontSize: '15px'
            }
        },
        xAxis: {
            categories: ['Ia', 'Ib', 'Ic'],
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            series: {
                pointWidth: 15,
                pointPadding: 0.05,
                groupPadding: 0.1,
            },
        },
        legend: {
            enabled: false,
        },
        series: [
            {
                name: 'Current',
                data: [50, 39, 20],
                colorByPoint: true,
                colors: ['#E46E6E', '#E4D354', '#7CB5EC'],
            },
        ],
    });

    useEffect(() => {
        setSelectedMarker(selectedMarker1);
    }, [selectedMarker1]);

    const slicedCode = code.toString().slice(0, 2);
    const stableApiKey = useRef(getGoogleMapsApiKey(slicedCode)).current;
    const companyCode = code.slice(0, 2);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: stableApiKey,
        libraries: mapLibraries,
    });

    // Cached map initialization: creates map only once, reuses on remount
    useEffect(() => {
        if (!isLoaded || !mapContainerRef.current) return;

        if (cachedMapInstance && cachedMapDiv) {
            // Reuse existing map - move its div back into our container
            mapContainerRef.current.innerHTML = '';
            mapContainerRef.current.appendChild(cachedMapDiv);
            mapRef.current = cachedMapInstance;

            // Clear all cached markers when remounting (so displayMode 'lineman' default works)
            if (cachedFieldStaffMarkers && cachedFieldStaffMarkers.length > 0) {
                cachedFieldStaffMarkers.forEach(marker => {
                    try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                });
                cachedFieldStaffMarkers = [];
            }
            if (cachedComplaintMarkers && cachedComplaintMarkers.length > 0) {
                cachedComplaintMarkers.forEach(marker => {
                    try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                });
                cachedComplaintMarkers = [];
            }
            if (cachedHeatmapLayer) {
                try { cachedHeatmapLayer.setMap(null); } catch (e) { }
                cachedHeatmapLayer = null;
            }
            if (cachedHeatmapInterval) {
                clearInterval(cachedHeatmapInterval);
                cachedHeatmapInterval = null;
            }

            setMap(cachedMapInstance);
            // Re-trigger the appropriate mapLoad for current hierarchy
            const m = cachedMapInstance;
            (hierarchy == 52) ? mapLoadSubdivision(m) : (hierarchy == 2 || hierarchy == 1) ? mapLoadCompany(m) : (hierarchy == 3) ? mapLoadCircle(m) : (hierarchy == 4 && divisionGeoJson) ? mapLoadDivision(m) : divisionGeoJson && mapLoadDivision(m);
        } else {
            // First time: create the map and cache it
            const div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            mapContainerRef.current.appendChild(div);

            const newMap = new window.google.maps.Map(div, {
                zoomControl: false,
                streetViewControl: false,
                minZoom: 4,
            });
            cachedMapInstance = newMap;
            cachedMapDiv = div;
            mapRef.current = newMap;
            setMap(newMap);
            // Call mapLoad for the first time
            (hierarchy == 52) ? mapLoadSubdivision(newMap) : (hierarchy == 2 || hierarchy == 1) ? mapLoadCompany(newMap) : (hierarchy == 3) ? mapLoadCircle(newMap) : (hierarchy == 4 && divisionGeoJson) ? mapLoadDivision(newMap) : divisionGeoJson && mapLoadDivision(newMap);
        }

        return () => {
            // On unmount: detach the map div but keep it alive
            if (cachedMapDiv && cachedMapDiv.parentNode) {
                cachedMapDiv.parentNode.removeChild(cachedMapDiv);
            }
            setMap(null);
        };
    }, [isLoaded]);

    const { data: result1 } = useSelector((state) => state.feederStatus);

    useEffect(() => {
        let coordinates = [];
        if (complaints.length > 0) {
            coordinates = [...coordinates, complaints.map(item => {
                return {
                    latitude: item.Latitude,
                    longitude: item.Longitude
                }
            })];
        }
    }, [complaints]);

    useEffect(() => {
        setSelectedMarker('');
    }, [complaints]);

    useEffect(() => {
        if (selectedMarker) {
            if (selectedMarker.kva) {
                const apmsCapacity = parseFloat(selectedMarker.apms_capacity) || 100;
                // const currentLoad = Math.abs(parseFloat(selectedMarker.kva));
                const currentLoad = parseFloat(selectedMarker.kva) || 0;
                // Calculate dynamic ranges based on APMS capacity
                const low = apmsCapacity * 0.25;
                const medium = apmsCapacity * 0.50;
                const high = apmsCapacity * 0.75;
                const max = apmsCapacity;

                console.log('Selected Marker KVA:', selectedMarker.kva, 'APMS Capacity:', apmsCapacity);

                setLoadOption(prevOptions => ({
                    ...prevOptions,
                    yAxis: {
                        ...prevOptions.yAxis,
                        min: 0,
                        max: max,
                        plotBands: [{
                            from: 0,
                            to: low,
                            color: '#05b129',
                            thickness: 30,
                            label: {
                                text: 'Low',
                                align: 'center',
                                style: {
                                    color: '#FFFFFF',
                                    fontSize: '10px',
                                    fontWeight: 'bold'
                                },
                                x: 30,
                                y: 20,
                                rotation: 0
                            }
                        }, {
                            from: low,
                            to: medium,
                            color: '#55BF3B',
                            thickness: 30,
                            label: {
                                text: 'Medium',
                                align: 'center',
                                style: {
                                    color: '#FFFFFF',
                                    fontSize: '10px',
                                    fontWeight: 'bold'
                                },
                                x: 40,
                                y: 30,
                                rotation: 0
                            }
                        }, {
                            from: medium,
                            to: high,
                            color: '#f69d26',
                            thickness: 30,
                            label: {
                                text: 'High',
                                align: 'center',
                                style: {
                                    color: '#FFFFFF',
                                    fontSize: '10px',
                                    fontWeight: 'bold'
                                },
                                x: -30,
                                y: 30,
                                rotation: 0
                            }
                        }, {
                            from: high,
                            to: max,
                            color: '#ef4b31',
                            thickness: 30,
                            label: {
                                text: 'Max',
                                align: 'center',
                                style: {
                                    color: '#FFFFFF',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                },
                                x: -30,
                                y: 20,
                                rotation: 0
                            }
                        }]
                    },
                    series: [{
                        ...prevOptions.series[0],
                        data: [currentLoad]
                    }]
                }));
                setVoltageOptions(prevOptions => ({
                    ...prevOptions,
                    series: [{
                        ...prevOptions.series[0],
                        data: [parseFloat(selectedMarker.v1), parseFloat(selectedMarker.v2), parseFloat(selectedMarker.v3)]
                    }]
                }));
                setCurrentOptions(prevOptions => ({
                    ...prevOptions,
                    series: [{
                        ...prevOptions.series[0],
                        data: [Math.abs(parseFloat(selectedMarker.i1)),
                        Math.abs(parseFloat(selectedMarker.i2)),
                        Math.abs(parseFloat(selectedMarker.i3))]
                    }]
                }));
            }
        }
    }, [selectedMarker]);

    const filteredFieldStaff = useMemo(() => {
        console.log("fieldStaff raw data:", fieldStaff);
        console.log("fieldStaff length:", fieldStaff?.length);

        // If no fieldStaff data, return empty array
        if (!fieldStaff || fieldStaff.length === 0) {
            console.log("No fieldStaff data available");
            return [];
        }

        // Get current hour and decide shift
        const now = new Date();
        const currentHour = now.getHours();

        let currentShiftId;
        if (currentHour >= 6 && currentHour < 14) {
            currentShiftId = "1";
        } else if (currentHour >= 14 && currentHour < 22) {
            currentShiftId = "2";
        } else {
            currentShiftId = "3";
        }
        console.log("Current shift:", currentShiftId, "Current hour:", currentHour);

        // Filter by shift - handle both shiftId (number) and shiftIds (comma-separated string)
        let result = fieldStaff.filter(item => {
            // If shiftIds exists as comma-separated string (e.g., "1,2,3")
            if (item.shiftIds) {
                const shiftIdsArray = item.shiftIds.toString().replace(/\s+/g, "").split(",");
                return shiftIdsArray.includes(currentShiftId);
            }
            // If shiftId exists as single value
            if (item.shiftId !== undefined) {
                return item.shiftId?.toString() === currentShiftId;
            }
            return true;
        });

        result = result.filter(item => {
            const designation = item.designationName?.toString().toUpperCase();
            return designation?.includes("ALM") ||
                designation?.includes("LM-I")   ||
                designation?.includes("LS-II")  ||
                designation?.includes("LM-II")  ||
                designation?.includes("LS-I")
        });

        // Filter out inactive linemen (not logged in)
        result = result.filter(item => item.isLogged_In === true || item.isLogged_In === 1);

        if (circleCode && homeButtonState === false) {
            result = result.filter(item => item.circleCode?.toString() == circleCode?.toString());
        }
        if (divisionCode && homeButtonState === false) {
            result = result.filter(item => item.divisionCode?.toString() == divisionCode?.toString());
        }
        // Filter by subdivision when selected (for hierarchy 1,2,3,4)
        if (setSubDivision && homeButtonState === false) {
            result = result.filter(item => {
                // Handle different subdivision code formats - compare first 5 digits
                const itemSubDiv = item.subDivisionCode?.toString()?.slice(0, 5);
                const selectedSubDiv = setSubDivision?.toString()?.slice(0, 5);
                return itemSubDiv == selectedSubDiv;
            });
            console.log("After subdivision filter:", result.length);
        }

        // Filter by selected designation if not 'all'
        if (selectedDesignationFilter && selectedDesignationFilter !== 'all') {
            result = result.filter(item => {
                const designation = item.designationName?.toString().toUpperCase();
                return designation?.includes(selectedDesignationFilter.toUpperCase());
            });
            console.log("After designation filter:", result.length);
        }

        console.log("Final filteredFieldStaff:", result.length, result);
        return result;
    }, [fieldStaff, circleCode, divisionCode, setSubDivision, homeButtonState, selectedDesignationFilter]);

    // Filter complaints based on drilldown level using RefNo
    // RefNo structure: 07111120508304
    // Position 3-4 (index 2-4): Company code (11)
    // Position 3-5 (index 2-5): Circle code (111)
    // Position 3-6 (index 2-6): Division code (1111)
    const filteredComplaints = useMemo(() => {
        if (!complaints || complaints.length === 0) return [];

        let result = [...complaints];

        // Filter by circle code
        if (circleCode && homeButtonState === false) {
            result = result.filter(item => {
                const refNoCircle = item.RefNo?.substring(2, 5);
                return refNoCircle === circleCode?.toString();
            });
        }

        // Filter by division code
        if (divisionCode && homeButtonState === false) {
            result = result.filter(item => {
                const refNoDivision = item.RefNo?.substring(2, 6);
                return refNoDivision === divisionCode?.toString();
            });
        }

        // Filter by subdivision when selected
        if (setSubDivision && homeButtonState === false) {
            result = result.filter(item => {
                const refNoSubDiv = item.RefNo?.substring(2, 7);
                return refNoSubDiv === setSubDivision?.toString()?.slice(0, 5);
            });
        }

        return result;
    }, [complaints, circleCode, divisionCode, setSubDivision, homeButtonState]);

    const getAPMSCoordinates = (connections) => {
        // Clear existing APMS markers first
        apmsMarkers.forEach(marker => marker.setMap(null));

        // Show APMS when user is subdivision level OR when drilling down to subdivision
        if ((hierarchy == 52 || setSubDivision) && connections && connections.length > 0) {
            const newApmsMarkers = [];
            connections.forEach(connection => {
                if (connection.latitude && connection.longitude) {
                    const marker = new window.google.maps.Marker({
                        position: { lat: parseFloat(connection.latitude), lng: parseFloat(connection.longitude) },
                        icon: {
                            url: (connection.contactor_status === 0) ? triangleoff : triangleon,
                            size: new window.google.maps.Size(28, 28),
                            scaledSize: new window.google.maps.Size(28, 28)
                        },
                        map,
                        title: connection.id,
                        zIndex: 100
                    });

                    const contentString = `
                    <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; z-index=2000 ">
                        <div >
                            <span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;">
                                ${connection.name || 'N/A'}
                            </span>
                        </div>
                        <br />
                        <p style="margin: 5px 0;"><strong>MSN:</strong> ${connection.msn || 'N/A'}</p>
                        <p style="margin: 5px 0; color: #fdff02;"><strong>Load:</strong> ${connection.kva} kVA</p>
                        <p style="margin: 5px 0;"><strong>Last Comm:</strong> ${connection.last_communication_time || 'N/A'}</p>
                        <p style="margin: 5px 0;"><strong>Contactor status:</strong> ${'N/A'}</p>
                    </div>`;

                    let customOverlay = null;
                    marker.addListener('mouseover', () => {
                        customOverlay && customOverlay.setMap(null);
                        customOverlay = createCustomOverlay(marker.getPosition(), contentString, map);
                    });
                    marker.addListener('mouseout', () => {
                        customOverlay && customOverlay.setMap(null);
                    });
                    marker.addListener('click', () => {
                        setSelectedMarker(connection);
                    });

                    newApmsMarkers.push(marker);
                }
            });
            setApmsMarkers(newApmsMarkers);
        } else {
            setApmsMarkers([]);
        }
    };

    const getComplaintsCoordinates = (complaints, clearLinemanMarkers = true) => {
        // Clear existing complaint markers first
        if (complaintMarkers && complaintMarkers.length > 0) {
            complaintMarkers.forEach(marker => {
                try {
                    if (marker && marker.getMap()) marker.setMap(null);
                } catch (e) { /* marker already removed */ }
            });
            cachedComplaintMarkers = [];
        }
        // Clear lineman markers only if not in 'both' mode
        if (clearLinemanMarkers && markers && markers.length > 0) {
            markers.forEach(marker => {
                try {
                    if (marker && marker.getMap()) marker.setMap(null);
                } catch (e) { /* marker already removed */ }
            });
            setMarkers([]);
            cachedFieldStaffMarkers = [];
        }

        if (map && complaints && complaints.length > 0) {
            const newComplaintMarkers = [];
            complaints.forEach(complaint => {
                // Only show Pending and Allocated complaints on map
                if (complaint.Latitude && complaint.Longitude && (complaint.Status === 'Pending' || complaint.Status === 'Allocated')) {
                    const marker = new window.google.maps.Marker({
                        position: { lat: parseFloat(complaint.Latitude), lng: parseFloat(complaint.Longitude) },
                        icon: {
                            url: complaint.Status === 'Allocated' ? blueCircle : redCircle,
                            size: new window.google.maps.Size(12, 12),
                            scaledSize: new window.google.maps.Size(12, 12)
                        },
                        map,
                    });

                    const contentString = `
                    <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; width: 200px;">
                      <div style="display: flex;">
                        <span style="flex-grow: 1; font-size: 14px; font-weight: bold;">
                          ${complaint.RefNo || 'N/A'}
                        </span>
                      </div>
                      <p style="margin: 5px 0; color: #fdff02">${complaint.Name || 'N/A'}</p>
                      <p style="margin: 5px 0;"> ${complaint.NearByFamousPlace || 'N/A'}</p>
                      ${complaint.userInfo ?
                            `<p style="margin: 5px 0;color: #fdff02">${complaint.userInfo.userFullName || 'N/A'} ${complaint.userInfo.userId ?
                                (complaint.userInfo.userId.startsWith('Lm') ? ' - Lineman' :
                                    complaint.userInfo.userId.startsWith('Alm') ? 'Asis Lineman' : complaint.userInfo.userId) :
                                'N/A'}</p>` : ''}
                    </div>`;

                    let customOverlay = null;
                    marker.addListener('mouseover', () => {
                        customOverlay && customOverlay.setMap(null);
                        customOverlay = createCustomOverlay(marker.getPosition(), contentString, map);
                    });

                    marker.addListener('mouseout', () => {
                        customOverlay && customOverlay.setMap(null);
                    });

                    marker.addListener('click', () => {
                        onComplaintsUpdate(complaint);
                        handleSubmit(complaint);
                    });

                    newComplaintMarkers.push(marker);
                }
            });
            setComplaintMarkers(newComplaintMarkers);
            // Also update cached markers for clearing on remount
            cachedComplaintMarkers = newComplaintMarkers;
        } else {
            setComplaintMarkers([]);
            cachedComplaintMarkers = [];
        }
    };

    const getFieldStaffCoordinates = (filteredFieldStaff, clearComplaintMarkers = true) => {
        console.log("getFieldStaffCoordinates called with:", filteredFieldStaff?.length, "items");
        console.log("Map available:", !!map);
        // Clear existing lineman markers first
        if (markers && markers.length > 0) {
            markers.forEach(marker => {
                try {
                    if (marker && marker.getMap()) marker.setMap(null);
                } catch (e) { /* marker already removed */ }
            });
            setMarkers([]);
            cachedFieldStaffMarkers = [];
        }
        // Clear complaint markers only if not in 'both' mode
        if (clearComplaintMarkers && complaintMarkers && complaintMarkers.length > 0) {
            complaintMarkers.forEach(marker => {
                try {
                    if (marker && marker.getMap()) marker.setMap(null);
                } catch (e) { /* marker already removed */ }
            });
            setComplaintMarkers([]);
            cachedComplaintMarkers = [];
        }

        if (map && filteredFieldStaff && filteredFieldStaff.length > 0) {
            console.log("Creating markers for", filteredFieldStaff.length, "field staff");
            const newMarkers = filteredFieldStaff.map(connection => {
                console.log("Processing connection:", connection.employeeName, "lat:", connection.latitude, "lng:", connection.longitude);
                if (connection.latitude && connection.longitude) {
                    const marker = new window.google.maps.Marker({
                        position: { lat: parseFloat(connection.latitude), lng: parseFloat(connection.longitude) },
                        icon: {
                            url: connection.isLogged_In == false ? offline : feild,
                            size: new window.google.maps.Size(60, 60),
                            scaledSize: new window.google.maps.Size(60, 60)
                        },
                        map,
                        title: connection.id,
                        zIndex: 10,
                        opacity: 1
                    });

                    const contentString = `
                    <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; z-index: 2000">
                        <div><span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;"><strong>Name:</strong> ${connection.employeeName || 'N/A'}</span></div>
                        <div><span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;"><strong>Designation:</strong> ${connection.designationName || 'N/A'}</span></div>
                        <div><span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;"><strong>Last Logged in Time:</strong> ${formatDate(connection.loggedIn_time) || 'N/A'}</span></div>
                        <div><span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;"><strong>Status:</strong> ${(connection.isLogged_In == false || connection.isLogged_In == null) ? 'Inactive' : 'Active'}</span></div>
                        <div><span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;"><strong>Sub Division:</strong> ${subdivisionName(parseInt(connection.subDivisionCode), subDivisions)}</span></div>
                    </div>`;

                    let customOverlay = null;
                    marker.addListener('mouseover', () => {
                        customOverlay && customOverlay.setMap(null);
                        customOverlay = createCustomOverlay(marker.getPosition(), contentString, map);
                    });
                    marker.addListener('mouseout', () => {
                        customOverlay && customOverlay.setMap(null);
                    });

                    return marker;
                }
                return null;
            }).filter(marker => marker !== null);

            setMarkers(newMarkers);
            // Also update cached markers for clearing on remount
            cachedFieldStaffMarkers = newMarkers;
        }
    };

    function createCustomOverlay(position, content, map) {
        const CustomOverlay = function () { };
        CustomOverlay.prototype = new window.google.maps.OverlayView();

        CustomOverlay.prototype.onAdd = function () {
            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.innerHTML = content;
            div.style.fontFamily = 'Arial, sans-serif';

            this.div = div;

            const panes = this.getPanes();
            panes.floatPane.appendChild(div);
        };

        CustomOverlay.prototype.draw = function () {
            const overlayProjection = this.getProjection();
            const pos = overlayProjection.fromLatLngToDivPixel(position);

            const div = this.div;
            div.style.left = pos.x + 'px';
            div.style.top = pos.y - 30 + 'px';
        };

        CustomOverlay.prototype.onRemove = function () {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                this.div = null;
            }
        };

        const overlay = new CustomOverlay();
        overlay.setMap(map);

        return overlay;
    }

    // Weather overlay: color polygons by weather and show info labels
    // Helper: find matching parentData circle for a GeoJSON feature
    const findMatchingCircle = (feature) => {
        if (!parentData || parentData.length === 0) return null;
        const featureName = feature.getProperty ? feature.getProperty('Name') || '' : (feature.Name || '');
        const featureCircle = feature.getProperty ? feature.getProperty('Circle') || '' : (feature.Circle || '');
        const featureCircleCode = feature.getProperty ? feature.getProperty('CircleCode') || '' : (feature.CircleCode || '');

        return parentData.find(p => {
            const pName = (p.name || '').toLowerCase().trim();
            const pCode = (p.Code || '').toString();
            const fName = featureName.toLowerCase().trim();
            const fCircle = featureCircle.toLowerCase().trim();
            const pNorm = pName.replace(/[\s.]+/g, '');
            const fNorm = fName.replace(/[\s.]+/g, '');
            const fCircleNorm = fCircle.replace(/[\s.]+/g, '');
            if (featureCircleCode && pCode && featureCircleCode.toString() === pCode.slice(0, 3)) return true;
            if (fCircle && (pName === fCircle || fCircle.includes(pName) || pName.includes(fCircle) || pNorm === fCircleNorm || fCircleNorm.includes(pNorm) || pNorm.includes(fCircleNorm))) return true;
            if (fName && (pName === fName || fName.includes(pName) || pName.includes(fName) || pNorm === fNorm || fNorm.includes(pNorm) || pNorm.includes(fNorm))) return true;
            return false;
        });
    };

    // Helper: get weather fill/stroke colors for a feature
    const getWeatherStyle = (feature) => {
        const match = findMatchingCircle(feature);
        if (!match || !weatherData || !weatherData[match.Code]) return null;
        const weather = weatherData[match.Code];
        const temp = weather.temp;
        const desc = (weather.description || '').toLowerCase();
        const isRain = desc.includes('rain') || desc.includes('storm') || desc.includes('thunder') || desc.includes('drizzle');

        let fillColor = '#81c784';
        let strokeColor = '#388e3c';
        if (temp >= 40) { fillColor = '#ef5350'; strokeColor = '#c62828'; }
        else if (isRain) { fillColor = '#42a5f5'; strokeColor = '#1565c0'; }
        else if (temp >= 38) { fillColor = '#ffa726'; strokeColor = '#e65100'; }
        return { fillColor, strokeColor };
    };

    const applyWeatherOverlays = (mapInstance) => {
        if (!mapInstance || !parentData || parentData.length === 0) {
            return;
        }

        // Create weather info overlays at polygon centroids
        const overlays = [];
        parentData.forEach((circle) => {
            // Use real weather data only
            const weather = weatherData?.[circle.Code];
            if (!weather) return; // Skip if no weather data available

            // Find the polygon bounds (min/max lat/lng)
            let minLat = Infinity, maxLat = -Infinity, minLng = Infinity, maxLng = -Infinity, count = 0;
            const geoData = geoJSON || divisionGeoJson;
            if (geoData && geoData.features) {
                geoData.features.forEach(feature => {
                    const fName = (feature.properties?.Name || '').toLowerCase().trim();
                    const fCircle = (feature.properties?.Circle || '').toLowerCase().trim();
                    const fCircleCode = (feature.properties?.CircleCode || '').toString();
                    const cName = (circle.name || '').toLowerCase().trim();
                    const cCode = (circle.Code || '').toString();
                    const fNorm = fName.replace(/[\s.]+/g, '');
                    const cNorm = cName.replace(/[\s.]+/g, '');
                    const fCircleNorm = fCircle.replace(/[\s.]+/g, '');
                    const nameMatch = (fName && (fName === cName || fName.includes(cName) || cName.includes(fName) || fNorm === cNorm || fNorm.includes(cNorm) || cNorm.includes(fNorm)));
                    const circleMatch = (fCircle && (cName === fCircle || fCircle.includes(cName) || cName.includes(fCircle) || cNorm === fCircleNorm || fCircleNorm.includes(cNorm) || cNorm.includes(fCircleNorm)));
                    const codeMatch = (fCircleCode && cCode && fCircleCode === cCode.slice(0, 3));
                    if ((nameMatch || circleMatch || codeMatch) && feature.properties?.SHAPE === 'Polygon') {
                        if (feature.geometry && feature.geometry.coordinates) {
                            feature.geometry.coordinates.forEach(polygon => {
                                polygon.forEach(ring => {
                                    ring.forEach(coord => {
                                        if (coord[1] < minLat) minLat = coord[1];
                                        if (coord[1] > maxLat) maxLat = coord[1];
                                        if (coord[0] < minLng) minLng = coord[0];
                                        if (coord[0] > maxLng) maxLng = coord[0];
                                        count++;
                                    });
                                });
                            });
                        }
                    }
                });
            }

            // If no matching polygon found, try to get from any feature
            if (count === 0 && geoData && geoData.features) {
                for (const feature of geoData.features) {
                    if (feature.geometry && feature.geometry.coordinates && count < 100) {
                        const coords = feature.geometry.coordinates;
                        if (coords[0] && coords[0][0]) {
                            coords[0].forEach(ring => {
                                if (Array.isArray(ring) && ring.length === 2 && typeof ring[0] === 'number') {
                                    if (ring[1] < minLat) minLat = ring[1];
                                    if (ring[1] > maxLat) maxLat = ring[1];
                                    if (ring[0] < minLng) minLng = ring[0];
                                    if (ring[0] > maxLng) maxLng = ring[0];
                                    count++;
                                } else if (Array.isArray(ring)) {
                                    ring.forEach(coord => {
                                        if (Array.isArray(coord) && coord.length >= 2) {
                                            if (coord[1] < minLat) minLat = coord[1];
                                            if (coord[1] > maxLat) maxLat = coord[1];
                                            if (coord[0] < minLng) minLng = coord[0];
                                            if (coord[0] > maxLng) maxLng = coord[0];
                                            count++;
                                        }
                                    });
                                }
                            });
                        }
                    }
                    if (count >= 100) break;
                }
            }

            if (count === 0 || maxLat === -Infinity) {
                return;
            }

            // Position at 25% from bottom (lower quarter of polygon), centered horizontally
            const badgeLat = minLat + (maxLat - minLat) * 0.25;
            const badgeLng = minLng + (maxLng - minLng) * 0.5;

            const desc = (weather.description || '').toLowerCase();
            const isRain = desc.includes('rain') || desc.includes('storm') || desc.includes('thunder') || desc.includes('drizzle');
            const isHeatwave = weather.temp >= 40;

            // Determine colors based on weather condition
            let bgGradient = 'linear-gradient(135deg, #66BB6A, #43A047)'; // Mild - green
            let shadowColor = 'rgba(76, 175, 80, 0.4)';
            if (isHeatwave) {
                bgGradient = 'linear-gradient(135deg, #FF5252, #D32F2F)';
                shadowColor = 'rgba(244, 67, 54, 0.4)';
            } else if (isRain) {
                bgGradient = 'linear-gradient(135deg, #42A5F5, #1E88E5)';
                shadowColor = 'rgba(33, 150, 243, 0.4)';
            } else if (weather.temp >= 38) {
                bgGradient = 'linear-gradient(135deg, #FFB74D, #FB8C00)';
                shadowColor = 'rgba(255, 152, 0, 0.4)';
            }

            const content = `
                <div style="
                    background: ${bgGradient};
                    color: white;
                    padding: 4px 10px;
                    border-radius: 14px;
                    font-size: 12px;
                    font-weight: 700;
                    text-align: center;
                    white-space: nowrap;
                    pointer-events: none;
                    box-shadow: 0 3px 8px ${shadowColor}, 0 1px 3px rgba(0,0,0,0.2);
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
                    letter-spacing: 0.3px;
                    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
                ">
                    ${weather.temp}°C
                </div>
            `;

            const overlay = createCustomOverlay(new window.google.maps.LatLng(badgeLat, badgeLng), content, mapInstance);
            overlays.push(overlay);
        });

        weatherOverlaysRef.current = overlays;
        cachedWeatherOverlays = overlays;
    };

    useEffect(() => {
        displayModeRef.current = displayMode;

        // Always remove old heatmap layer and blink interval
        if (heatmapBlinkRef.current) {
            clearInterval(heatmapBlinkRef.current);
            heatmapBlinkRef.current = null;
        }
        if (heatmapLayerRef.current) {
            heatmapLayerRef.current.setMap(null);
            heatmapLayerRef.current = null;
        }

        // Always remove old weather overlays
        if (weatherOverlaysRef.current && weatherOverlaysRef.current.length > 0) {
            weatherOverlaysRef.current.forEach(overlay => {
                try { overlay.setMap(null); } catch (e) { }
            });
            weatherOverlaysRef.current = [];
            cachedWeatherOverlays = [];
        }

        // Dull the background polygons in heatmap/weather mode, restore in other modes
        if (map && map.data) {
            if (displayMode === 'heatmap' || displayMode === 'weather') {
                map.data.forEach(feature => {
                    map.data.overrideStyle(feature, {
                        fillOpacity: 0.05,
                        strokeOpacity: 0.8,
                        strokeWeight: 1.5
                    });
                });
            } else {
                map.data.forEach(feature => map.data.revertStyle(feature));
            }
        }

        if (isLoaded && map && hierarchy == 52) {
            console.log("useEffect triggered - hierarchy 52, displayMode:", displayMode, "filteredFieldStaff:", filteredFieldStaff?.length);
            getAPMSCoordinates(connections);
            // Respect displayMode for hierarchy 52 as well
            if (displayMode === 'lineman') {
                console.log("Calling getFieldStaffCoordinates for lineman mode");
                getFieldStaffCoordinates(filteredFieldStaff, true);
            } else if (displayMode === 'complaints') {
                getComplaintsCoordinates(filteredComplaints, true);
            } else if (displayMode === 'both') {
                getFieldStaffCoordinates(filteredFieldStaff, false);
                getComplaintsCoordinates(filteredComplaints, false);
            } else if (displayMode === 'heatmap') {
                // Clear all existing markers for heatmap mode
                if (markers && markers.length > 0) {
                    markers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setMarkers([]);
                }
                if (complaintMarkers && complaintMarkers.length > 0) {
                    complaintMarkers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setComplaintMarkers([]);
                }
                // Create heatmap from complaints
                if (filteredComplaints && filteredComplaints.length > 0) {
                    const heatmapData = filteredComplaints
                        .filter(c => c.Latitude && c.Longitude && (c.Status === 'Pending' || c.Status === 'Allocated'))
                        .map(c => ({
                            location: new window.google.maps.LatLng(parseFloat(c.Latitude), parseFloat(c.Longitude)),
                            weight: c.Status === 'Pending' ? 2 : 1
                        }));
                    if (heatmapData.length > 0) {
                        const heatmap = new window.google.maps.visualization.HeatmapLayer({
                            data: heatmapData,
                            map: map,
                            radius: 35,
                            opacity: 1,
                            dissipating: true,
                            gradient: [
                                'rgba(255, 255, 0, 0)',
                                'rgba(255, 220, 0, 0.5)',
                                'rgba(255, 180, 0, 0.7)',
                                'rgba(255, 120, 0, 0.85)',
                                'rgba(255, 60, 0, 0.9)',
                                'rgba(230, 20, 0, 0.95)',
                                'rgba(180, 0, 0, 1)',
                                'rgba(120, 0, 0, 1)'
                            ]
                        });
                        heatmapLayerRef.current = heatmap;
                        cachedHeatmapLayer = heatmap;
                    }
                }
            } else if (displayMode === 'weather') {
                // Clear all existing markers for weather mode
                if (markers && markers.length > 0) {
                    markers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setMarkers([]);
                }
                if (complaintMarkers && complaintMarkers.length > 0) {
                    complaintMarkers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setComplaintMarkers([]);
                }
                applyWeatherOverlays(map);
            }
        } else if (isLoaded && map) {
            // When returning to company level (homeButtonState is true), clear ALL markers first
            if (homeButtonState) {
                // Clear APMS markers
                apmsMarkers.forEach(marker => marker.setMap(null));
                setApmsMarkers([]);
                // Clear complaint markers
                if (complaintMarkers && complaintMarkers.length > 0) {
                    complaintMarkers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setComplaintMarkers([]);
                }
                // Clear lineman/field staff markers
                if (markers && markers.length > 0) {
                    markers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setMarkers([]);
                }
            }
            // All other levels (Company, Circle, Division): toggle
            // Show APMS when drilled down to subdivision level (but NOT when returning to company)
            if (setSubDivision && !homeButtonState) {
                getAPMSCoordinates(connections);
            } else {
                // Clear APMS markers when not at subdivision level OR when returning to company
                apmsMarkers.forEach(marker => marker.setMap(null));
                setApmsMarkers([]);
            }
            if (displayMode === 'lineman') {
                // Show lineman only
                getFieldStaffCoordinates(filteredFieldStaff, true);
            } else if (displayMode === 'complaints') {
                // Show complaints only (filtered by drilldown level)
                getComplaintsCoordinates(filteredComplaints, true);
            } else if (displayMode === 'both') {
                // Show both lineman and complaints (don't clear each other's markers)
                getFieldStaffCoordinates(filteredFieldStaff, false);
                getComplaintsCoordinates(filteredComplaints, false);
            } else if (displayMode === 'heatmap') {
                // Clear all existing markers
                if (markers && markers.length > 0) {
                    markers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setMarkers([]);
                }
                if (complaintMarkers && complaintMarkers.length > 0) {
                    complaintMarkers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setComplaintMarkers([]);
                }

                // Create heatmap from complaints (Pending + Allocated with valid coordinates)
                if (filteredComplaints && filteredComplaints.length > 0) {
                    const heatmapData = filteredComplaints
                        .filter(c => c.Latitude && c.Longitude && (c.Status === 'Pending' || c.Status === 'Allocated'))
                        .map(c => ({
                            location: new window.google.maps.LatLng(parseFloat(c.Latitude), parseFloat(c.Longitude)),
                            weight: c.Status === 'Pending' ? 2 : 1
                        }));

                    if (heatmapData.length > 0) {
                        const heatmap = new window.google.maps.visualization.HeatmapLayer({
                            data: heatmapData,
                            map: map,
                            radius: 35,
                            opacity: 1,
                            dissipating: true,
                            gradient: [
                                'rgba(255, 255, 0, 0)',
                                'rgba(255, 220, 0, 0.5)',
                                'rgba(255, 180, 0, 0.7)',
                                'rgba(255, 120, 0, 0.85)',
                                'rgba(255, 60, 0, 0.9)',
                                'rgba(230, 20, 0, 0.95)',
                                'rgba(180, 0, 0, 1)',
                                'rgba(120, 0, 0, 1)'
                            ]
                        });
                        heatmapLayerRef.current = heatmap;
                        cachedHeatmapLayer = heatmap;

                        // Smooth fade in/out pulse effect
                        let opacity = 1;
                        let direction = -1; // -1 = fading out, 1 = fading in
                        const interval = setInterval(() => {
                            if (heatmapLayerRef.current) {
                                opacity += direction * 0.03;
                                if (opacity <= 0.35) {
                                    opacity = 0.35;
                                    direction = 1;
                                } else if (opacity >= 1) {
                                    opacity = 1;
                                    direction = -1;
                                }
                                heatmapLayerRef.current.set('opacity', opacity);
                            }
                        }, 40);
                        heatmapBlinkRef.current = interval;
                        cachedHeatmapInterval = interval;
                    }
                }
            } else if (displayMode === 'weather') {
                // Clear all existing markers for weather mode
                if (markers && markers.length > 0) {
                    markers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setMarkers([]);
                }
                if (complaintMarkers && complaintMarkers.length > 0) {
                    complaintMarkers.forEach(marker => {
                        try { if (marker && marker.getMap()) marker.setMap(null); } catch (e) { }
                    });
                    setComplaintMarkers([]);
                }
                applyWeatherOverlays(map);
            }
        }
        if (selectedMarker) {
            onComplaintsUpdate(selectedMarker.complaitData);
        }
    }, [isLoaded, map, filteredComplaints, connections, filteredFieldStaff, circleCode, divisionCode, setSubDivision, hierarchy, displayMode, weatherData, parentData]);

    useEffect(() => {
        if (result1) {
            const feederInfor = result1.map(item => ({
                feeder_code: item.feeder_code,
                feeder: item.feeder,
                current_status: item.current_status,
                current: item.current
            }));
            setFeederInfo(feederInfor);
        }
    }, [result1]);

    const removeLeadingZeros = (feederArray) => {
        return feederArray.map(feeder => ({
            feeder_code: parseInt(feeder.feeder_code, 10),
            feeder: feeder.feeder,
            current_status: feeder.current_status,
            current: feeder.current,
            grid: feeder.grid
        }));
    };

    const colors1 = ['#83BBB0', '#93B5E3', '#9790C1', '#99DCF2', '#C2E392', '#979C8E', '#EAC59A'];
    const reversedColors = colors1.reverse();
    const colors2 = ['#137D69', '#3071C9', '#392B89', '#3DBCE7', '#8AC92E', '#384227', '#D7903E'];
    const reversedColors2 = colors2.reverse();

    const mapRef = useRef(null);

    useEffect(() => {
        setData1(color ? reversedColors : reversedColors2);
    }, [color]);

    useEffect(() => {
        if (mapRef.current && geoJSON && feederInfo) {
            mapRef.current.data.setStyle((feature) => {
                const feederCode = feature.getProperty('Feeder Code');
                return {
                    strokeColor: colorByFeederCode(feederCode, feederInfo),
                    strokeWeight: 2,
                };
            });
        }
    }, [data1, feederInfo]);

    const colorByFeederCode = (feederCode, feederInfo) => {
        if (feederInfo) {
            const feederCodeData = removeLeadingZeros(feederInfo);
            const feeder = feederCodeData.find(f => f.feeder_code == feederCode);
            if (feeder) {
                if (feeder.current <= 3 && feeder.current_status == "OFF") {
                    return color ? '#f07971' : 'red';
                } else {
                    const feederIndex = feederCode % data1.length;
                    return data1[feederIndex];
                }
            }
        }
    };

    const flashInterval = 1000;

    useEffect(() => {
        const intervalId = setInterval(() => {
            setFlash((prevFlash) => !prevFlash);
        }, flashInterval);

        return () => clearInterval(intervalId);
    }, [flashInterval]);

    const resetStyling = (map) => {
        map.setOptions({ styles: '' });
    };

    const mapLoadSubdivision = async (map) => {
        if (map) {
            mapRef.current = map;
            map.data.forEach((feature) => {
                map.data.remove(feature);
            });
            map.setOptions({ styles: mapStyle });

            if (geoJSON) {
                const latitudes = [];
                const longitudes = [];

                const companyCode = code.slice(0, 2);

                if (companyCode == 11 || companyCode == 14) {
                    geoJSON.features.forEach((item) => {
                        if (item?.geometry?.type === "MultiLineString" && Array.isArray(item.geometry.coordinates)) {
                            item.geometry.coordinates.forEach((line) => {
                                line.forEach((coord) => {
                                    longitudes.push(coord[0]);
                                    latitudes.push(coord[1]);
                                });
                            });
                        }
                    });
                } else {
                    geoJSON.features.forEach((item) => {
                        if (item?.geometry?.coordinates?.forEach) {
                            item.geometry.coordinates.forEach((coordArray) => {
                                if (Array.isArray(coordArray)) {
                                    coordArray.forEach((coord) => {
                                        if (Array.isArray(coord)) {
                                            longitudes.push(coord[0]);
                                            latitudes.push(coord[1]);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }

                const minLat = Math.min(...latitudes);
                const maxLat = Math.max(...latitudes);
                const minLng = Math.min(...longitudes);
                const maxLng = Math.max(...longitudes);

                // Always center map when subdivision is selected or hierarchy 52
                if (hierarchy == 52 || setSubDivision) {
                    if (window.google && latitudes.length > 0 && longitudes.length > 0) {
                        const bounds = new window.google.maps.LatLngBounds();
                        bounds.extend(new window.google.maps.LatLng(minLat, minLng));
                        bounds.extend(new window.google.maps.LatLng(maxLat, maxLng));

                        map.fitBounds(bounds);

                        const listener = window.google.maps.event.addListener(map, "bounds_changed", () => {
                            const currentZoom = map.getZoom();
                            if (currentZoom < 12) {
                                map.setZoom(12);
                            }
                            window.google.maps.event.removeListener(listener);
                        });
                    }
                }

                map.data.addGeoJson(geoJSON);
                map.data.setStyle((feature) => ({
                    strokeColor: colorByFeederCode(feature.getProperty('Feeder Code'), feederInfo),
                    strokeWeight: (displayModeRef.current === 'heatmap' || displayModeRef.current === 'weather') ? 1.5 : 2,
                    fillOpacity: (displayModeRef.current === 'heatmap' || displayModeRef.current === 'weather') ? 0.05 : 0,
                }));

                let customOverlay = null;

                const val = removeLeadingZeros(result1);
                map.data.addListener('mouseover', (event) => {
                    const feederCode = event.feature.getProperty('Feeder Code');
                    const matchingFeeder = val.find(feeder => feeder.feeder_code == feederCode);
                    if (matchingFeeder) {
                        const contentString = `
                            <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; width: 200px;">
                              <div style="display: flex;">
                                <span style="flex-grow: 1; font-size: 16px; font-weight: bold;">
                                  ${feederCode || 'N/A'}
                                </span>
                                <span style="flex-grow: 1; font-size: 16px; font-weight: bold; margin-left: 5px; color: #f98126;">
                                  ${matchingFeeder.current_status === 'OFF' && matchingFeeder.current < 3 ? 'OFF' : ''}
                                </span>
                                <img src="${InfoImage}" style="margin-left: 20px; width: 20px; height: 20px;" />
                              </div>
                              <p style="margin: 5px 0; color:#fdff02;">${'11 KV ' + (matchingFeeder.feeder || 'N/A')}</p>
                              <p style="margin: 5px 0;">${matchingFeeder.grid || 'N/A'}</p>
                              <p style="color: #fdff02;">${matchingFeeder.current_status === 'OFF' && matchingFeeder.current < 3 ? '' : matchingFeeder.current + ' Amps'}</p>
                            </div>
                        `;
                        customOverlay && customOverlay.setMap(null);
                        customOverlay = createCustomOverlay(event.latLng, contentString, map);
                    }
                });

                map.data.addListener('mouseout', () => {
                    customOverlay && customOverlay.setMap(null);
                });
            }
            resetStyling(map);
            setMap(map);

            // Load APMS markers after map is ready for hierarchy 52 or when drilling down to subdivision
            if ((hierarchy == 52 || setSubDivision) && connections && connections.length > 0) {
                // Clear existing APMS markers
                apmsMarkers.forEach(marker => marker.setMap(null));

                const newApmsMarkers = [];
                connections.forEach(connection => {
                    if (connection.latitude && connection.longitude) {
                        const marker = new window.google.maps.Marker({
                            position: { lat: parseFloat(connection.latitude), lng: parseFloat(connection.longitude) },
                            icon: {
                                url: (connection.contactor_status === 0) ? triangleoff : triangleon,
                                size: new window.google.maps.Size(28, 28),
                                scaledSize: new window.google.maps.Size(28, 28)
                            },
                            map,
                            title: connection.id,
                            zIndex: 100
                        });

                        const contentString = `
                        <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; z-index=2000 ">
                            <div >
                                <span style="flex-grow: 1; font-size: 16px; font-weight: bold; color: #fdff02;">
                                    ${connection.name || 'N/A'}
                                </span>
                            </div>
                            <br />
                            <p style="margin: 5px 0;"><strong>MSN:</strong> ${connection.msn || 'N/A'}</p>
                            <p style="margin: 5px 0; color: #fdff02;"><strong>Load:</strong> ${connection.kva} kVA</p>
                            <p style="margin: 5px 0;"><strong>Last Comm:</strong> ${connection.last_communication_time || 'N/A'}</p>
                            <p style="margin: 5px 0;"><strong>Contactor status:</strong> ${'N/A'}</p>
                        </div>`;

                        let customOverlay = null;
                        marker.addListener('mouseover', () => {
                            customOverlay && customOverlay.setMap(null);
                            customOverlay = createCustomOverlay(marker.getPosition(), contentString, map);
                        });
                        marker.addListener('mouseout', () => {
                            customOverlay && customOverlay.setMap(null);
                        });
                        marker.addListener('click', () => {
                            setSelectedMarker(connection);
                        });

                        newApmsMarkers.push(marker);
                    }
                });
                setApmsMarkers(newApmsMarkers);
            }
        }
    };

    const colorArray = [
        "#e3c088",
        "#c4dfac",
        "#fdf89a",
        "#9eecf3",
        "#d4e2fb",
        "#caf8ff",
        "#b2b5ea",
        "#aad3f0",
        "#fee4e5",
    ];

    let colorIndex = 0;

    const getNextColor = () => {
        const color = colorArray[colorIndex];
        colorIndex = (colorIndex + 1) % colorArray.length;
        return color;
    };

    const [divisionName, setDivisionName] = useState(null);
    const [circleName, setCircleName] = useState(null);

    useEffect(() => {
        setCircleName("");
        setDivisionName("");
    }, [setCode]);

    const mapStyle = [
        {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": [{ "color": "#d3d3d3" }, { "lightness": -25 }, { "saturation": -50 }]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [{ "color": "#d3d3d3" }]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [{ "visibility": "on" }]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{ "color": "#d3d3d3" }]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{ "color": "#d3d3d3" }, { "visibility": "off" }]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{ "color": "#a0d6d1" }]
        },
    ];

    const mapStyle1 = [
        {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": [{ "color": "#d3d3d3" }, { "lightness": -25 }, { "saturation": -50 }]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [{ "visibility": "on" }]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{ "color": "#d3d3d3" }]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{ "color": "#d3d3d3" }, { "visibility": "off" }]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{ "color": "#a0d6d1" }]
        },
    ];

    const mapLoadCompany = async (map) => {
        if (map) {
            mapRef.current = map;
            map.data.forEach((feature) => {
                map.data.remove(feature);
            });
            if (setCode) {
                map.setOptions({ styles: mapStyle1 });
            } else {
                map.setOptions({ styles: mapStyle });
            }
            if (geoJSON) {
                const latitudes = [];
                const longitudes = [];

                let filteredGeoJSON = {};


                console.log("filteredGeoJSON", filteredGeoJSON);
                if (homeButtonState) {
                    console.log("1");
                    filteredGeoJSON = {
                        type: "FeatureCollection",
                        features: geoJSON.features.filter(
                            (item) => item.properties['SHAPE'] === "Polygon"
                        ),
                    };
                } else if ((setCode && !setDivision && code == "11" && homeButtonState == false)) {
                    console.log("2");
                    filteredGeoJSON = {
                        type: "FeatureCollection",
                        features: geoJSON.features.filter(
                            (item) => item.properties['SHAPE'] === "Polygon" && item.properties.Circle == setCode
                        ),
                    };
                } else if ((setCode && !setDivision && homeButtonState == false)) {
                    console.log("3");
                    filteredGeoJSON = {
                        type: "FeatureCollection",
                        features: (divisionGeoJson?.features || []).filter(
                            (item) => item.properties['SHAPE'] === "Polygon" && item.properties.Circle == setCode
                        ),
                    };
                } else if (setDivision && hierarchy != 52 && homeButtonState == false) {
                    console.log("4");
                    console.log(divisionGeoJson, 'filteredGeoJSON 4')
                    filteredGeoJSON = {
                        type: "FeatureCollection",
                        features: (divisionGeoJson?.features || []).filter(
                            (item) => item.properties['SHAPE'] === "Polygon" && item.properties.Circle == setCode && item.properties.Name === setDivision.trim()
                        ),
                    };
                } else {
                    console.log("5");
                    if (geoJSON && geoJSON.features) {
                        filteredGeoJSON = {
                            type: "FeatureCollection",
                            features: geoJSON.features.filter(
                                (item) => item.properties['SHAPE'] === "Polygon"
                            ),
                        };
                    } else {
                        let codeToGeoJSON = code;
                        await dispatch(fetchGeoJson({ subDivisionCode: codeToGeoJSON.slice(0, 2), roleTypeId: roleTypeId }));
                    }
                }

                filteredGeoJSON.features.forEach((item) => {
                    item.geometry.coordinates.forEach((polygon) => {
                        polygon.forEach((ring) => {
                            ring.forEach((coord) => {
                                longitudes.push(coord[0]);
                                latitudes.push(coord[1]);
                            });
                        });
                    });
                });

                const minLat = Math.min(...latitudes);
                const maxLat = Math.max(...latitudes);
                const minLng = Math.min(...longitudes);
                const maxLng = Math.max(...longitudes);

                if (window.google) {
                    const margin = 0.05;
                    const adjustedBounds = new window.google.maps.LatLngBounds();
                    adjustedBounds.extend({ lat: minLat - margin, lng: minLng - margin });
                    adjustedBounds.extend({ lat: maxLat + margin, lng: maxLng + margin });
                    if (setCode || circleName) {
                        const tightMargin = 0.05;
                        const latMargin = (maxLat - minLat) * tightMargin;
                        const lngMargin = (maxLng - minLng) * tightMargin;

                        const adjustedBounds = new window.google.maps.LatLngBounds(
                            { lat: minLat + latMargin, lng: minLng + lngMargin },
                            { lat: maxLat - latMargin, lng: maxLng - lngMargin }
                        );

                        map.fitBounds(adjustedBounds);
                    } else {
                        map.fitBounds(adjustedBounds);
                    }
                }

                map.data.forEach((feature) => {
                    map.data.remove(feature);
                });
                map.data.addGeoJson(filteredGeoJSON);
                map.data.setStyle((feature) => {
                    const shapeType = feature.getProperty('SHAPE');
                    const isHeatmap = displayModeRef.current === 'heatmap' || displayModeRef.current === 'weather';
                    if (displayModeRef.current === 'weather' && shapeType === 'Polygon') {
                        const wStyle = getWeatherStyle(feature);
                        if (wStyle) return { strokeColor: wStyle.strokeColor, strokeWeight: 2, strokeOpacity: 1, fillColor: wStyle.fillColor, fillOpacity: 0.45 };
                    }
                    return {
                        strokeColor: '#00008B',
                        strokeWeight: 1.5,
                        strokeOpacity: isHeatmap ? 0.8 : 1,
                        fillColor: shapeType === 'Polygon' ? getNextColor() : '#FFFFFF',
                        fillOpacity: isHeatmap ? 0.05 : (shapeType === 'Polygon' ? 0.3 : 0),
                    };
                });
                let customOverlay = null;
                map.data.addListener('mouseover', (event) => {
                    const name = event.feature.getProperty('Name');
                    const circleProp = event.feature.getProperty('Circle');
                    const circleCode = event.feature.getProperty('CircleCode');

                    // Get weather info if in heatmap mode
                    let weatherHtml = '';
                    if (displayModeRef.current === 'heatmap' && weatherData && parentData) {
                        console.log('Weather Debug - Feature:', { name, circleProp, circleCode });
                        console.log('Weather Debug - parentData:', parentData.map(p => ({ name: p.name, Code: p.Code, childrenCount: p.children?.length })));
                        console.log('Weather Debug - weatherData keys:', Object.keys(weatherData));

                        // Helper function to normalize names for comparison
                        const normalize = (str) => (str || '').toLowerCase().trim().replace(/[\s.]+/g, '');

                        // Try to find matching circle or division
                        let matchedCircle = null;
                        let matchedWeatherCode = null;

                        const fName = (name || '').toLowerCase().trim();
                        const fCircle = (circleProp || '').toLowerCase().trim();
                        const fNorm = normalize(name);
                        const fCircleNorm = normalize(circleProp);

                        // First try to match by circle code
                        if (circleCode) {
                            matchedCircle = parentData.find(p => {
                                const pCode = (p.Code || '').toString();
                                return pCode.startsWith(circleCode.toString().slice(0, 3));
                            });
                        }

                        // If not found, try matching by name against circles
                        if (!matchedCircle) {
                            matchedCircle = parentData.find(p => {
                                const pName = (p.name || '').toLowerCase().trim();
                                const pNorm = normalize(p.name);

                                // Direct match or contains match
                                if (fCircle && (pName === fCircle || fCircle.includes(pName) || pName.includes(fCircle) || pNorm === fCircleNorm || fCircleNorm.includes(pNorm) || pNorm.includes(fCircleNorm))) return true;
                                if (fName && (pName === fName || fName.includes(pName) || pName.includes(fName) || pNorm === fNorm || fNorm.includes(pNorm) || pNorm.includes(fNorm))) return true;
                                return false;
                            });
                        }

                        // If still not found, check if the name matches a division (child of a circle)
                        if (!matchedCircle) {
                            for (const parent of parentData) {
                                if (parent.children && parent.children.length > 0) {
                                    const matchedChild = parent.children.find(child => {
                                        const cName = (child.name || '').toLowerCase().trim();
                                        const cNorm = normalize(child.name);
                                        return fName === cName || fNorm === cNorm || fName.includes(cName) || cName.includes(fName) || fNorm.includes(cNorm) || cNorm.includes(fNorm);
                                    });
                                    if (matchedChild) {
                                        matchedWeatherCode = matchedChild.Code;
                                        if (!weatherData[matchedChild.Code]) {
                                            matchedCircle = parent;
                                            matchedWeatherCode = parent.Code;
                                        }
                                        break;
                                    }
                                }
                            }
                        }

                        if (matchedCircle && !matchedWeatherCode) {
                            matchedWeatherCode = matchedCircle.Code;
                        }

                        console.log('Weather Debug - matchedCircle:', matchedCircle, 'matchedWeatherCode:', matchedWeatherCode);
                        if (matchedCircle && matchedWeatherCode) {
                            const weather = weatherData[matchedWeatherCode];
                            if (weather) {
                                const desc = (weather.description || '').toLowerCase();
                                const isRain = desc.includes('rain') || desc.includes('storm') || desc.includes('thunder');
                                const isHeatwave = weather.temp >= 40;
                                let bgColor = '#4CAF50';
                                if (isHeatwave) bgColor = '#F44336';
                                else if (isRain) bgColor = '#2196F3';
                                else if (weather.temp >= 38) bgColor = '#FF9800';
                                weatherHtml = `
                                    <div style="margin-top: 8px; padding: 6px 10px; background: ${bgColor}; border-radius: 8px; display: inline-block;">
                                        <span style="font-size: 18px; font-weight: bold;">${weather.temp}°C</span>
                                    </div>
                                `;
                            }
                        }
                    }

                    const contentString = `
                            <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; min-width: 150px;">
                              <div style="display: flex;">
                                <span style="flex-grow: 1; font-size: 16px; font-weight: bold;">
                                  ${name}
                                </span>
                              </div>
                              ${weatherHtml}
                            </div>
                        `;
                    customOverlay && customOverlay.setMap(null);
                    customOverlay = createCustomOverlay(event.latLng, contentString, map);
                });

                map.data.addListener('click', (event) => {
                    const name = event.feature.getProperty('Name');
                    if (circleName) {
                        setCircleName("");
                        setDivisionName(name);
                    } else {
                        setCircleName(name);
                        setDivisionName("");
                    }
                });
                map.data.addListener('mouseout', () => {
                    customOverlay && customOverlay.setMap(null);
                });
            }
            setMap(map);
        }
    };

    const mapLoadCircle = async (map) => {
        if (map) {
            mapRef.current = map;
            map.data.forEach((feature) => {
                map.data.remove(feature);
            });
            if (setCode) {
                map.setOptions({ styles: mapStyle1 });
            } else {
                map.setOptions({ styles: mapStyle });
            }
            if (geoJSON) {
                const latitudes = [];
                const longitudes = [];

                let filteredGeoJSON = {};


                console.log("setDivision:", divisionGeoJson);
                if (setDivision) {
                    filteredGeoJSON = {
                        type: "FeatureCollection",
                        features: (divisionGeoJson?.features || []).filter(
                            (item) => item.properties['SHAPE'] === "Polygon" && item.properties.CircleCode == (hierarchy == 3 ? (CircleCode || officeCode) : officeCode) && item.properties.Name === setDivision
                        ),
                    };
                } else {
                    const circleCodeToUse = hierarchy == 3 ? (CircleCode || code) : (officeCode ? officeCode : code);
                    filteredGeoJSON = {
                        type: "FeatureCollection",
                        features: (divisionGeoJson?.features || []).filter(
                            (item) => item.properties['SHAPE'] === "Polygon" && item.properties.CircleCode == circleCodeToUse
                        ),
                    };
                }

                filteredGeoJSON.features.forEach((item) => {
                    item.geometry.coordinates.forEach((polygon) => {
                        polygon.forEach((ring) => {
                            ring.forEach((coord) => {
                                longitudes.push(coord[0]);
                                latitudes.push(coord[1]);
                            });
                        });
                    });
                });
                const minLat = Math.min(...latitudes);
                const maxLat = Math.max(...latitudes);
                const minLng = Math.min(...longitudes);
                const maxLng = Math.max(...longitudes);

                if (window.google) {
                    const margin = 0.05;
                    const adjustedBounds = new window.google.maps.LatLngBounds();
                    adjustedBounds.extend({ lat: minLat - margin, lng: minLng - margin });
                    adjustedBounds.extend({ lat: maxLat + margin, lng: maxLng + margin });
                    if (setCode || circleName) {
                        const tightMargin = 0.05;
                        const latMargin = (maxLat - minLat) * tightMargin;
                        const lngMargin = (maxLng - minLng) * tightMargin;

                        const adjustedBounds = new window.google.maps.LatLngBounds(
                            { lat: minLat + latMargin, lng: minLng + lngMargin },
                            { lat: maxLat - latMargin, lng: maxLng - lngMargin }
                        );

                        map.fitBounds(adjustedBounds);
                    } else {
                        map.fitBounds(adjustedBounds);
                    }
                }

                map.data.forEach((feature) => {
                    map.data.remove(feature);
                });

                map.data.addGeoJson(filteredGeoJSON);

                map.data.setStyle((feature) => {
                    const shapeType = feature.getProperty('SHAPE');
                    const isHeatmap = displayModeRef.current === 'heatmap' || displayModeRef.current === 'weather';
                    if (displayModeRef.current === 'weather' && shapeType === 'Polygon') {
                        const wStyle = getWeatherStyle(feature);
                        if (wStyle) return { strokeColor: wStyle.strokeColor, strokeWeight: 2, strokeOpacity: 1, fillColor: wStyle.fillColor, fillOpacity: 0.45 };
                    }
                    return {
                        strokeColor: '#00008B',
                        strokeWeight: 1.5,
                        strokeOpacity: isHeatmap ? 0.8 : 1,
                        fillColor: shapeType === 'Polygon' ? getNextColor() : '#FFFFFF',
                        fillOpacity: isHeatmap ? 0.05 : (shapeType === 'Polygon' ? 0.3 : 0),
                    };
                });
                let customOverlay = null;
                map.data.addListener('mouseover', (event) => {
                    const name = event.feature.getProperty('Name');
                    const circleProp = event.feature.getProperty('Circle');
                    const circleCode = event.feature.getProperty('CircleCode');

                    // Get weather info if in heatmap mode
                    let weatherHtml = '';
                    if (displayModeRef.current === 'heatmap' && weatherData && parentData) {
                        console.log('Weather Debug - Feature:', { name, circleProp, circleCode });
                        console.log('Weather Debug - parentData:', parentData.map(p => ({ name: p.name, Code: p.Code, childrenCount: p.children?.length })));
                        console.log('Weather Debug - weatherData keys:', Object.keys(weatherData));

                        // Helper function to normalize names for comparison
                        const normalize = (str) => (str || '').toLowerCase().trim().replace(/[\s.]+/g, '');

                        // Try to find matching circle or division
                        let matchedCircle = null;
                        let matchedWeatherCode = null;

                        const fName = (name || '').toLowerCase().trim();
                        const fCircle = (circleProp || '').toLowerCase().trim();
                        const fNorm = normalize(name);
                        const fCircleNorm = normalize(circleProp);

                        // First try to match by circle code
                        if (circleCode) {
                            matchedCircle = parentData.find(p => {
                                const pCode = (p.Code || '').toString();
                                return pCode.startsWith(circleCode.toString().slice(0, 3));
                            });
                        }

                        // If not found, try matching by name against circles
                        if (!matchedCircle) {
                            matchedCircle = parentData.find(p => {
                                const pName = (p.name || '').toLowerCase().trim();
                                const pNorm = normalize(p.name);

                                // Direct match or contains match
                                if (fCircle && (pName === fCircle || fCircle.includes(pName) || pName.includes(fCircle) || pNorm === fCircleNorm || fCircleNorm.includes(pNorm) || pNorm.includes(fCircleNorm))) return true;
                                if (fName && (pName === fName || fName.includes(pName) || pName.includes(fName) || pNorm === fNorm || fNorm.includes(pNorm) || pNorm.includes(fNorm))) return true;
                                return false;
                            });
                        }

                        // If still not found, check if the name matches a division (child of a circle)
                        if (!matchedCircle) {
                            for (const parent of parentData) {
                                if (parent.children && parent.children.length > 0) {
                                    const matchedChild = parent.children.find(child => {
                                        const cName = (child.name || '').toLowerCase().trim();
                                        const cNorm = normalize(child.name);
                                        return fName === cName || fNorm === cNorm || fName.includes(cName) || cName.includes(fName) || fNorm.includes(cNorm) || cNorm.includes(fNorm);
                                    });
                                    if (matchedChild) {
                                        matchedWeatherCode = matchedChild.Code;
                                        if (!weatherData[matchedChild.Code]) {
                                            matchedCircle = parent;
                                            matchedWeatherCode = parent.Code;
                                        }
                                        break;
                                    }
                                }
                            }
                        }

                        if (matchedCircle && !matchedWeatherCode) {
                            matchedWeatherCode = matchedCircle.Code;
                        }

                        console.log('Weather Debug - matchedCircle:', matchedCircle, 'matchedWeatherCode:', matchedWeatherCode);
                        if (matchedCircle && matchedWeatherCode) {
                            const weather = weatherData[matchedWeatherCode];
                            if (weather) {
                                const desc = (weather.description || '').toLowerCase();
                                const isRain = desc.includes('rain') || desc.includes('storm') || desc.includes('thunder');
                                const isHeatwave = weather.temp >= 40;
                                let bgColor = '#4CAF50';
                                if (isHeatwave) bgColor = '#F44336';
                                else if (isRain) bgColor = '#2196F3';
                                else if (weather.temp >= 38) bgColor = '#FF9800';
                                weatherHtml = `
                                    <div style="margin-top: 8px; padding: 6px 10px; background: ${bgColor}; border-radius: 8px; display: inline-block;">
                                        <span style="font-size: 18px; font-weight: bold;">${weather.temp}°C</span>
                                    </div>
                                `;
                            }
                        }
                    }

                    const contentString = `
                            <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; min-width: 150px;">
                              <div style="display: flex;">
                                <span style="flex-grow: 1; font-size: 16px; font-weight: bold;">
                                  ${name}
                                </span>
                              </div>
                              ${weatherHtml}
                            </div>
                        `;
                    customOverlay && customOverlay.setMap(null);
                    customOverlay = createCustomOverlay(event.latLng, contentString, map);
                });

                map.data.addListener('click', (event) => {
                    const name = event.feature.getProperty('Name');
                    if (circleName) {
                        setCircleName("");
                        setDivisionName(name);
                    } else {
                        setCircleName(name);
                        setDivisionName("");
                    }
                });
                map.data.addListener('mouseout', () => {
                    customOverlay && customOverlay.setMap(null);
                });
            }
            setMap(map);
        }
    };

    // Load subdivision view for hierarchy 4 when geoJSON is not available but divisionGeoJson is
    const mapLoadSubdivisionFromDivision = async (map) => {
        if (map && divisionGeoJson && setSubDivision) {
            console.log("mapLoadSubdivisionFromDivision called with setSubDivision:", setSubDivision);
            mapRef.current = map;
            map.data.forEach((feature) => {
                map.data.remove(feature);
            });
            map.setOptions({ styles: mapStyle });

            const latitudes = [];
            const longitudes = [];

            // Get subdivision code - take first 5 digits
            const subDivCode = setSubDivision?.toString()?.slice(0, 5);
            const divCode = setSubDivision?.toString()?.slice(0, 4);
            console.log("Filtering for subDivCode:", subDivCode, "divCode:", divCode);

            // Filter divisionGeoJson to get the selected subdivision's or division's boundary
            const filteredGeoJSON = {
                type: "FeatureCollection",
                features: (divisionGeoJson?.features || []).filter((item) => {
                    if (item.properties['SHAPE'] !== "Polygon") return false;
                    // Try multiple property names for matching
                    const props = item.properties;
                    const featureSubDivCode = (props.SubDivisionCode || props.subdivisionCode || props.SubdivisionCode || '').toString();
                    const featureDivCode = (props.DivisionCode || props.divisionCode || '').toString();
                    const featureName = (props.Name || props.name || '').toString();

                    // Match by subdivision code, division code, or by checking if within the same division
                    return featureSubDivCode === subDivCode ||
                           featureDivCode === divCode ||
                           featureDivCode === subDivCode?.slice(0, 4);
                }),
            };
            console.log("Filtered features count:", filteredGeoJSON.features.length);

            // If no features found, fallback to showing the division area
            if (filteredGeoJSON.features.length === 0) {
                console.log("No matching subdivision features, using division polygon");
                // Try to find any polygon in the current division
                filteredGeoJSON.features = (divisionGeoJson?.features || []).filter((item) => {
                    if (item.properties['SHAPE'] !== "Polygon") return false;
                    const props = item.properties;
                    const featureDivCode = (props.DivisionCode || props.divisionCode || '').toString();
                    const featureCircleCode = (props.CircleCode || props.circleCode || '').toString();
                    // Match by division or circle
                    return featureDivCode === divCode || featureCircleCode === subDivCode?.slice(0, 3);
                });
                console.log("Fallback features count:", filteredGeoJSON.features.length);
            }

            if (filteredGeoJSON.features.length > 0) {
                filteredGeoJSON.features.forEach((item) => {
                    if (item.geometry?.coordinates) {
                        item.geometry.coordinates.forEach((polygon) => {
                            polygon.forEach((ring) => {
                                ring.forEach((coord) => {
                                    longitudes.push(coord[0]);
                                    latitudes.push(coord[1]);
                                });
                            });
                        });
                    }
                });

                if (latitudes.length > 0 && longitudes.length > 0) {
                    const minLat = Math.min(...latitudes);
                    const maxLat = Math.max(...latitudes);
                    const minLng = Math.min(...longitudes);
                    const maxLng = Math.max(...longitudes);

                    if (window.google) {
                        const bounds = new window.google.maps.LatLngBounds();
                        bounds.extend(new window.google.maps.LatLng(minLat, minLng));
                        bounds.extend(new window.google.maps.LatLng(maxLat, maxLng));
                        map.fitBounds(bounds);

                        const listener = window.google.maps.event.addListener(map, "bounds_changed", () => {
                            const currentZoom = map.getZoom();
                            if (currentZoom < 12) {
                                map.setZoom(12);
                            }
                            window.google.maps.event.removeListener(listener);
                        });
                    }
                }

                map.data.addGeoJson(filteredGeoJSON);
                map.data.setStyle((feature) => ({
                    strokeColor: '#4285F4',
                    strokeWeight: 2,
                    fillColor: '#4285F4',
                    fillOpacity: 0.1,
                }));
            }
            setMap(map);
        }
    };

    const mapLoadDivision = async (map) => {

        if (map) {
            mapRef.current = map;
            map.data.forEach((feature) => {
                map.data.remove(feature);
            });
            if (setCode) {
                map.setOptions({ styles: mapStyle1 });
            } else {
                map.setOptions({ styles: mapStyle });
            }

            const latitudes = [];
            const longitudes = [];

            let filteredGeoJSON = {};

            if (setDivision) {
                filteredGeoJSON = {
                    type: "FeatureCollection",
                    features: (divisionGeoJson?.features || []).filter(
                        (item) => item.properties['SHAPE'] === "Polygon" && item.properties.Circle == "MULTAN" && item.properties.Name == setDivision
                    ),
                };
            } else {
                // Use officeCode if available, otherwise use code from auth
                const officeCodeStr = officeCode?.toString() || code?.toString() || '';
                filteredGeoJSON = {
                    type: "FeatureCollection",
                    features: (divisionGeoJson?.features || []).filter(
                        (item) => {
                            if (item.properties['SHAPE'] !== "Polygon") return false;
                            // For hierarchy 4 (division level), filter by DivisionCode only
                            if (hierarchy == 4) {
                                return item.properties.DivisionCode == officeCodeStr.slice(0, 4);
                            }
                            // For other levels, filter by both CircleCode and DivisionCode
                            return item.properties.CircleCode == officeCodeStr.slice(0, 3) && item.properties.DivisionCode == officeCodeStr.slice(0, 4);
                        }
                    ),
                };
            }

            filteredGeoJSON.features.forEach((item) => {
                item.geometry.coordinates.forEach((polygon) => {
                    polygon.forEach((ring) => {
                        ring.forEach((coord) => {
                            longitudes.push(coord[0]);
                            latitudes.push(coord[1]);
                        });
                    });
                });
            });
            const minLat = Math.min(...latitudes);
            const maxLat = Math.max(...latitudes);
            const minLng = Math.min(...longitudes);
            const maxLng = Math.max(...longitudes);

            if (window.google) {
                const margin = 0.05;
                const adjustedBounds = new window.google.maps.LatLngBounds();
                adjustedBounds.extend({ lat: minLat - margin, lng: minLng - margin });
                adjustedBounds.extend({ lat: maxLat + margin, lng: maxLng + margin });
                if (setCode || circleName) {
                    const tightMargin = 0.05;
                    const latMargin = (maxLat - minLat) * tightMargin;
                    const lngMargin = (maxLng - minLng) * tightMargin;

                    const adjustedBounds = new window.google.maps.LatLngBounds(
                        { lat: minLat + latMargin, lng: minLng + lngMargin },
                        { lat: maxLat - latMargin, lng: maxLng - lngMargin }
                    );

                    map.fitBounds(adjustedBounds);
                } else {
                    map.fitBounds(adjustedBounds);
                }
            }

            map.data.forEach((feature) => {
                map.data.remove(feature);
            });

            map.data.addGeoJson(filteredGeoJSON);

            map.data.setStyle((feature) => {
                const shapeType = feature.getProperty('SHAPE');
                const isHeatmap = displayModeRef.current === 'heatmap' || displayModeRef.current === 'weather';
                return {
                    strokeColor: '#00008B',
                    strokeWeight: 1.5,
                    strokeOpacity: isHeatmap ? 0.8 : 1,
                    fillColor: shapeType === 'Polygon' ? getNextColor() : '#FFFFFF',
                    fillOpacity: isHeatmap ? 0.05 : (shapeType === 'Polygon' ? 0.3 : 0),
                };
            });
            let customOverlay = null;
            map.data.addListener('mouseover', (event) => {
                const name = event.feature.getProperty('Name');

                const contentString = `
                            <div style="padding: 10px; background-color: #333; border-radius: 10px; color: white; font-family: Arial, sans-serif; width: 200px;">
                              <div style="display: flex;">
                                <span style="flex-grow: 1; font-size: 16px; font-weight: bold;">
                                  ${name}
                                </span>
                              </div>
                            </div>
                        `;
                customOverlay && customOverlay.setMap(null);
                customOverlay = createCustomOverlay(event.latLng, contentString, map);
            });

            map.data.addListener('click', (event) => {
                const name = event.feature.getProperty('Name');
                if (circleName) {
                    setCircleName("");
                    setDivisionName(name);
                } else {
                    setCircleName(name);
                    setDivisionName("");
                }
            });
            map.data.addListener('mouseout', () => {
                customOverlay && customOverlay.setMap(null);
            });
            setMap(map);
        }
    };

    useEffect(() => {
        // Check if geoJSON has actual features
        const hasGeoJSONFeatures = geoJSON && geoJSON.features && geoJSON.features.length > 0;
        const hasDivisionGeoJson = divisionGeoJson && divisionGeoJson.features && divisionGeoJson.features.length > 0;

        console.log("Map useEffect - hierarchy:", hierarchy, "setSubDivision:", setSubDivision, "hasGeoJSONFeatures:", hasGeoJSONFeatures, "hasDivisionGeoJson:", hasDivisionGeoJson, "homeButtonState:", homeButtonState, "map:", !!map);

        // PRIORITY: When homeButtonState is true (going back to company), load company map regardless of other conditions
        if (homeButtonState && (hierarchy == 1 || hierarchy == 2) && hasGeoJSONFeatures) {
            console.log("Calling mapLoadCompany (homeButtonState is true - returning to company)");
            mapLoadCompany(map);
        }
        // When subdivision is selected (any hierarchy) and geoJSON has features, load subdivision map with feeder lines
        else if (setSubDivision && hasGeoJSONFeatures) {
            console.log("Calling mapLoadSubdivision (geoJSON available)");
            mapLoadSubdivision(map);
        } else if (setSubDivision && hierarchy == 4 && hasDivisionGeoJson) {
            // For hierarchy 4 with subdivision selected but no geoJSON features, use divisionGeoJson
            console.log("Calling mapLoadSubdivisionFromDivision (hierarchy 4 fallback)");
            mapLoadSubdivisionFromDivision(map);
        } else if (hierarchy == 52 && hasGeoJSONFeatures) {
            console.log("Calling mapLoadSubdivision (hierarchy 52)");
            mapLoadSubdivision(map);
        } else if ((hierarchy == 2 || hierarchy == 1) && hasGeoJSONFeatures) {
            console.log("Calling mapLoadCompany");
            mapLoadCompany(map);
        } else if (hierarchy == 3 && hasDivisionGeoJson) {
            console.log("Calling mapLoadCircle");
            mapLoadCircle(map);
        } else if (hierarchy == 4 && hasDivisionGeoJson && !setSubDivision) {
            // For hierarchy 4, show division map when no subdivision is selected
            console.log("Calling mapLoadDivision (hierarchy 4, no subdivision)");
            mapLoadDivision(map);
        } else if (hasDivisionGeoJson) {
            console.log("Calling mapLoadDivision (fallback)");
            mapLoadDivision(map);
        } else {
            console.log("No condition matched in map useEffect");
        }
    }, [feederInfo, fieldStaff, connections, geoJSON, setCode, setDivision, setSubDivision, circleName, divisionName, company, complaints, geoJSON, homeButtonState, divisionGeoJson]);

    const toggleSwitch = () => {
        if (color) {
            dispatch(updateColor(false));
        } else {
            dispatch(updateColor(true));
        }
    };

    const dispatch = useDispatch();

    const updateFeederStatus = (geoJSON) => {
        if (geoJSON) {
            const features = geoJSON.features;
            const feederArray = [];

            if (features) {
                const feederFeatures = features.filter((feature) => feature.properties["Feeder Code"] != null && feature.properties["Feeder Code"] != "11kV");
                let feederString = '';
                feederFeatures.forEach((feature) => {
                    const feederCode = feature.properties["Feeder Code"];
                    if (feederCode) {
                        if (!feederArray.includes(feederCode)) {
                            feederString.concat(feederCode.toString()).concat(',');
                            feederArray.push(feederCode);
                        }
                    }
                });

                feederString = feederArray.join(',');
                dispatch(fetchFeederStatus(feederString));
            }
        }
    };

    useEffect(() => {
        updateFeederStatus(geoJSON);
        const intervalId = setInterval(() => {
            updateFeederStatus(geoJSON);
        }, 60000);
        return () => clearInterval(intervalId);
    }, [geoJSON]);

    // onUnmount not needed - cached map persists across mounts

    const handleInfoWindowOpen = () => { };

    const handleKeyPress = (event) => {
        if (event.key === 'Y' || event.key === 'y') {
            if (verificationPopup) {
                handleYes('popup1');
            } else if (verificationPopup1) {
                handleYes('popup2');
            }
        } else if (event.key === 'N' || event.key === 'n') {
            handleNo();
        }
    };

    const handleYes = (popup) => {
        if (popup === 'popup1') {
            setVerificationPopup(false);
            setVerificationPopup1(true);
        } else if (popup === 'popup2') {
            setShowFeedbackDropdown(true);
        }
    };

    const handleNo = () => {
        setVerificationPopup(false);
        setVerificationPopup1(false);
    };

    useEffect(() => {
        if (verificationPopup || verificationPopup1) {
            window.addEventListener('keydown', handleKeyPress);
        } else {
            window.removeEventListener('keydown', handleKeyPress);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [verificationPopup, verificationPopup1]);

    const handleReason = (event) => {
        setReason(event.target.value);
    };

    const handleSubmitTurnOff = async () => {
        const header = `msn=${selectedMarker.msn}&aux=off&remarks=${reason}`;
        const base64Header = btoa(header);
        // Implementation of fetch request remains unchanged
    };

    return isLoaded ? (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <div ref={mapContainerRef} style={{ width: '100%', height: '100%' }} />
            <MapContext.Provider value={map}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none' }}>
                    <div style={{ pointerEvents: 'auto' }}>
                        <div className={`switch-container ${color ? 'on' : 'off'}`} style={{ top: 50, left: 30 }} onClick={toggleSwitch}>
                            <div style={{ width: "30px", marginLeft: color ? 10 : 80, marginTop: 3, display: "flex" }}>
                                <p style={{ fontSize: 12, color: 'white', marginTop: 3 }}>{color ? "Light Mode" : "Dark Mode"}</p>
                            </div>
                            <div className="switch-circle"></div>
                        </div>
                        {/* Toggle for Company/Circle/Division levels to switch between Complaints and Lineman */}
                        {(hierarchy == 1 || hierarchy == 2 || hierarchy == 3 || hierarchy == 4) && (
                            <div style={{
                                position: 'absolute',
                                top: 10,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                gap: '15px',
                                backgroundColor: 'rgba(0,57,113,0.95)',
                                padding: '8px 20px',
                                borderRadius: '8px',
                                alignItems: 'center',
                                zIndex: 1000
                            }}>
                                {/* Company Name */}
                                {company && (
                                    <span style={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}>{company}</span>
                                )}
                                {/* Separator */}
                                {company && <div style={{ width: '1px', height: '24px', backgroundColor: 'rgba(255,255,255,0.3)' }}></div>}
                                {/* Three-way Segmented Toggle with counts */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.25)',
                                    borderRadius: '8px',
                                    padding: '3px',
                                    gap: '3px'
                                }}>
                                    <div
                                        onClick={() => setDisplayMode('lineman')}
                                        style={{
                                            padding: '5px 14px',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            backgroundColor: displayMode === 'lineman' ? 'rgba(46, 204, 113, 0.9)' : 'transparent',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            border: displayMode === 'lineman' ? 'none' : '1px solid transparent'
                                        }}
                                    >
                                        {/* Signal indicator */}
                                        <div style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: (filteredFieldStaff && filteredFieldStaff.length > 0) ? '#00ff00' : '#ff0000',
                                            boxShadow: (filteredFieldStaff && filteredFieldStaff.length > 0) ? '0 0 6px #00ff00' : '0 0 6px #ff0000'
                                        }}></div>
                                        <span style={{
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: '500'
                                        }}>Line Staff</span>
                                        <span style={{
                                            backgroundColor: displayMode === 'lineman' ? 'rgba(255,255,255,0.95)' : 'rgba(46, 204, 113, 0.85)',
                                            color: displayMode === 'lineman' ? '#1e8449' : '#fff',
                                            fontSize: '11px',
                                            padding: '3px 8px',
                                            borderRadius: '12px',
                                            fontWeight: '700',
                                            minWidth: '20px',
                                            textAlign: 'center',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                        }}>{filteredFieldStaff ? filteredFieldStaff.length : 0}</span>
                                    </div>
                                    {/* Designation Dropdown Filter */}
                                    <Select
                                        value={selectedDesignationFilter}
                                        onChange={(e) => setSelectedDesignationFilter(e.target.value)}
                                        size="small"
                                        renderValue={(value) => (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <span style={{
                                                    width: '8px',
                                                    height: '8px',
                                                    borderRadius: '50%',
                                                    backgroundColor: value === 'all' ? '#2ecc71' :
                                                        value === 'ALM' ? '#e74c3c' :
                                                        value === 'LM-I' ? '#3498db' :
                                                        value === 'LM-II' ? '#9b59b6' :
                                                        value === 'LS-I' ? '#f39c12' : '#1abc9c'
                                                }}></span>
                                                <span>{value === 'all' ? 'All' : value}</span>
                                            </div>
                                        )}
                                        sx={{
                                            minWidth: 95,
                                            height: 30,
                                            backgroundColor: selectedDesignationFilter !== 'all' ? 'rgba(46, 204, 113, 0.15)' : 'rgba(0,0,0,0.25)',
                                            color: 'white',
                                            fontSize: '11px',
                                            fontWeight: 500,
                                            borderRadius: '6px',
                                            '& .MuiSelect-icon': { color: 'rgba(255,255,255,0.7)', fontSize: '18px' },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: selectedDesignationFilter !== 'all' ? 'rgba(46, 204, 113, 0.5)' : 'transparent'
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(46, 204, 113, 0.7)' },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2ecc71' },
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    backgroundColor: '#1a2942',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                                                    border: '1px solid rgba(255,255,255,0.1)',
                                                    mt: 0.5,
                                                    '& .MuiMenuItem-root': {
                                                        color: 'white',
                                                        fontSize: '12px',
                                                        padding: '8px 12px',
                                                        '&:hover': { backgroundColor: 'rgba(46, 204, 113, 0.15)' },
                                                        '&.Mui-selected': {
                                                            backgroundColor: 'rgba(46, 204, 113, 0.25)',
                                                            '&:hover': { backgroundColor: 'rgba(46, 204, 113, 0.3)' }
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value="all">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#2ecc71' }}></span>
                                                <span style={{ flex: 1 }}>All</span>
                                                <span style={{
                                                    backgroundColor: 'rgba(46, 204, 113, 0.2)',
                                                    color: '#2ecc71',
                                                    padding: '2px 6px',
                                                    borderRadius: '10px',
                                                    fontSize: '10px',
                                                    fontWeight: 600
                                                }}>{filteredFieldStaff?.length || 0}</span>
                                            </div>
                                        </MenuItem>
                                        <MenuItem value="ALM">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#e74c3c' }}></span>
                                                <span style={{ flex: 1 }}>ALM</span>
                                            </div>
                                        </MenuItem>
                                        <MenuItem value="LM-I">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#3498db' }}></span>
                                                <span style={{ flex: 1 }}>LM-I</span>
                                            </div>
                                        </MenuItem>
                                        <MenuItem value="LM-II">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#9b59b6' }}></span>
                                                <span style={{ flex: 1 }}>LM-II</span>
                                            </div>
                                        </MenuItem>
                                        <MenuItem value="LS-I">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#f39c12' }}></span>
                                                <span style={{ flex: 1 }}>LS-I</span>
                                            </div>
                                        </MenuItem>
                                        <MenuItem value="LS-II">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#1abc9c' }}></span>
                                                <span style={{ flex: 1 }}>LS-II</span>
                                            </div>
                                        </MenuItem>
                                    </Select>
                                    <div
                                        onClick={() => setDisplayMode('both')}
                                        style={{
                                            padding: '5px 14px',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            backgroundColor: displayMode === 'both' ? 'rgba(52, 152, 219, 0.9)' : 'transparent',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        {/* Combined signal - green/red split */}
                                        <div style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, ' +
                                                ((filteredFieldStaff && filteredFieldStaff.length > 0) ? '#00ff00' : '#ff0000') + ' 50%, ' +
                                                ((filteredComplaints && filteredComplaints.length > 0) ? '#00ff00' : '#ff0000') + ' 50%)',
                                            boxShadow: '0 0 4px rgba(52, 152, 219, 0.5)'
                                        }}></div>
                                        <span style={{
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: '500'
                                        }}>Both</span>
                                    </div>
                                    <div
                                        onClick={() => setDisplayMode('complaints')}
                                        style={{
                                            padding: '5px 14px',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            backgroundColor: displayMode === 'complaints' ? 'rgba(231, 76, 60, 0.9)' : 'transparent',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        {/* Signal indicator */}
                                        <div style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: (filteredComplaints && filteredComplaints.length > 0) ? '#00ff00' : '#ff0000',
                                            boxShadow: (filteredComplaints && filteredComplaints.length > 0) ? '0 0 6px #00ff00' : '0 0 6px #ff0000'
                                        }}></div>
                                        <span style={{
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: '500'
                                        }}>Complaints</span>
                                        <span style={{
                                            backgroundColor: displayMode === 'complaints' ? 'rgba(255,255,255,0.95)' : 'rgba(231, 76, 60, 0.85)',
                                            color: displayMode === 'complaints' ? '#922b21' : '#fff',
                                            fontSize: '11px',
                                            padding: '3px 8px',
                                            borderRadius: '12px',
                                            fontWeight: '700',
                                            minWidth: '20px',
                                            textAlign: 'center',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                        }}>{filteredComplaints ? filteredComplaints.length : 0}</span>
                                    </div>
                                    <div
                                        onClick={() => setDisplayMode('heatmap')}
                                        style={{
                                            padding: '5px 14px',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            backgroundColor: displayMode === 'heatmap' ? 'rgba(255, 140, 0, 0.9)' : 'transparent',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        <div style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #00ff00 0%, #ffff00 50%, #ff0000 100%)',
                                            boxShadow: displayMode === 'heatmap' ? '0 0 6px rgba(255,140,0,0.8)' : 'none'
                                        }}></div>
                                        <span style={{
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: '500'
                                        }}>Heat Map</span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Weather Legend - Show on heatmap mode */}
                        {displayMode === 'heatmap' && (
                            <div style={{
                                position: 'absolute',
                                bottom: '15px',
                                left: '15px',
                                backgroundColor: 'rgba(0,0,0,0.8)',
                                borderRadius: '8px',
                                padding: '10px 14px',
                                zIndex: 10,
                                pointerEvents: 'auto',
                            }}>
                                <div style={{ color: 'white', fontWeight: 'bold', fontSize: '12px', marginBottom: '8px', borderBottom: '1px solid rgba(255,255,255,0.3)', paddingBottom: '5px' }}>
                                    Weather Legend
                                </div>
                                {[
                                    { color: '#ef5350', label: 'Heatwave', desc: '>= 40°C' },
                                    { color: '#ffa726', label: 'Hot', desc: '38°C – 39°C' },
                                    { color: '#81c784', label: 'Mild', desc: '< 38°C' },
                                    { color: '#42a5f5', label: 'Rain / Storm', desc: 'Any temp' },
                                ].map((item, i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: i < 3 ? '5px' : 0 }}>
                                        <div style={{
                                            width: '14px',
                                            height: '14px',
                                            borderRadius: '3px',
                                            backgroundColor: item.color,
                                            border: '1px solid rgba(255,255,255,0.4)',
                                            flexShrink: 0,
                                        }}></div>
                                        <span style={{ color: 'white', fontSize: '11px', fontWeight: '600' }}>{item.label}</span>
                                        <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '10px' }}>{item.desc}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                        {selectedMarker && (
                            <InfoWindow
                                position={{
                                    lat: parseFloat(),
                                    lng: parseFloat(),
                                }}
                                style={{ color: 'white', borderRadius: '30px', height: '500px' }}
                                onCloseClick={() => { setSelectedMarker(null); updateSelectedMarker1(); }}
                                onOpen={handleInfoWindowOpen}
                                options={{ disableAutoPan: true }}
                            >
                                <>
                                    {
                                        selectedMarker.apms_capacity ?
                                            <div>
                                                <div style={{ height: 'auto', display: 'flex' }}>
                                                    <div style={{ width: '220px', height: ' increae', backgroundColor: '#F2F3F4', padding: '10px', borderRadius: '5px' }}>
                                                        <p style={{ padding: '5px 0px' }}><span style={{ fontWeight: '800', fontSize: 12 }}>{selectedMarker.name} KVA</span></p>
                                                        {
                                                            selectedMarker.kva < 0 &&
                                                            <p style={{ padding: '5px 0px', color: 'red', textAlign: 'center' }}><span style={{ fontWeight: '800', fontSize: 15, letterSpacing: '2px' }}>NET METER</span></p>
                                                        }
                                                        <div>
                                                            <div
                                                                className={`switch-container1 ${(selectedMarker.contactor_status !== 0) ? 'off' : 'on'}`}
                                                                style={{ left: 30, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                                                onClick={() => { if (selectedMarker.contactor_status) { setVerificationPopup(true) } }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: '30px',
                                                                        marginLeft: (selectedMarker.contactor_status !== 0) ? 80 : 10,
                                                                        marginTop: 3,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    <p
                                                                        style={{
                                                                            fontSize: 12,
                                                                            color: (selectedMarker.contactor_status !== 0) ? 'white' : 'white',
                                                                            fontWeight: 'bold',
                                                                            marginTop: 0,
                                                                            marginBottom: 0
                                                                        }}
                                                                    >
                                                                        {(selectedMarker.contactor_status !== 0) ? 'ON' : 'OFF'}
                                                                    </p>
                                                                </div>
                                                                <div className="switch-circle"></div>
                                                            </div>
                                                            <hr style={{ borderTop: '1px solid gray', marginTop: '10px', width: '100%' }} />
                                                        </div>
                                                        <HighchartsReact highcharts={Highcharts} options={loadOption} />
                                                        <div style={{
                                                            backgroundColor: selectedMarker.kva > 0 ? 'red' : '#E7A350',
                                                            width: '40%',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            margin: '0 auto',
                                                            padding: '5px',
                                                            borderRadius: 8,
                                                            marginTop: -30
                                                        }}>
                                                            <p style={{ textAlign: 'center', color: 'white', fontSize: 20 }}>{selectedMarker.kva}</p>
                                                            <p style={{ textAlign: 'center', color: 'white', fontSize: 20 }}>kVA</p>
                                                        </div>
                                                    </div>
                                                    <div style={{ width: '200px', height: 'auto', backgroundColor: '#F2F3F4', padding: '10px', margin: '0px 10px', borderRadius: '5px' }}>
                                                        <HighchartsReact highcharts={Highcharts} options={voltageOptions} />
                                                        <HighchartsReact highcharts={Highcharts} options={currentOptions} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto auto', gap: 20, backgroundColor: '#d5e5ff', padding: '10px', borderRadius: '10px' }}>
                                                <div style={{ height: 'auto', }}>
                                                    <p style={{ padding: '5px 0px' }}>Complaint Id: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.ticketNo}</p>
                                                </div>
                                                <div style={{ height: 'auto', }}>
                                                    <p style={{ padding: '5px 0px' }}>Ref No.: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.refNo}</p>
                                                </div>
                                                <div style={{ height: 'auto', }}>
                                                    <p style={{ padding: '5px 0px' }}>Complaint Type: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.complaintType}</p>
                                                </div>
                                                <div style={{ height: 'auto', }}>
                                                    <p style={{ padding: '5px 0px' }}>Registered At: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.registeredAt ? convertDatewithTime(selectedMarker.complaitData.registeredAt) : '-'}</p>
                                                </div>
                                                <div style={{ height: 'auto' }}>
                                                    <p style={{ padding: '5px 0px' }}>Applicant Name: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.name}</p>
                                                </div>
                                                <div style={{ height: 'auto' }}>
                                                    <p style={{ padding: '5px 0px' }}>Address: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.nearByFamousPlace}</p>
                                                </div>
                                                <div style={{ height: 'auto' }}>
                                                    <p style={{ padding: '5px 0px' }}>Phone No.: </p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.mobile}</p>
                                                </div>
                                                {
                                                    selectedMarker.complaitData.status == 'Allocated' &&
                                                    <div style={{ height: 'auto' }}>
                                                        <p style={{ padding: '5px 0px' }}>Assign to:</p>
                                                        <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.allocatedTo.userId}</p>
                                                    </div>
                                                }
                                                {
                                                    selectedMarker.complaitData.status == 'Pending' &&
                                                    <DialogActions>
                                                        <Button variant="contained" sx={{ width: '15%' }}
                                                            component="label" type='submit' onClick={handleSubmit}
                                                        >Assign</Button>
                                                    </DialogActions>
                                                }
                                            </div>
                                    }
                                </>
                            </InfoWindow>
                        )}
                        {verificationPopup && (
                            <div className="App">
                                <button>Turn Off APMS</button>
                                <div className="modal-overlay">
                                    <div className="modal-content">
                                        <img src={poweron} />
                                        <h2> Turn Off APMS?</h2>
                                        <p style={{ padding: '5px 0px' }}><span style={{ fontWeight: '800', fontSize: 15 }}>{selectedMarker.name} KVA</span></p>
                                        <p>
                                            Do you want to <strong style={{ fontWeight: 'bold' }}>Turn Off</strong> APMS
                                        </p>
                                        <p>
                                            <strong style={{ fontWeight: 'bold', fontSize: 30, color: 'red' }}>
                                                Y
                                            </strong>
                                            <strong style={{ fontSize: 20, marginLeft: -5 }}>
                                                es
                                            </strong>
                                            <strong style={{ fontSize: 25 }}>
                                                /
                                            </strong>
                                            <strong style={{ fontWeight: 'bold', fontSize: 30, color: 'green' }}>
                                                N
                                            </strong>
                                            <strong style={{ fontSize: 20, marginLeft: 0 }}>
                                                o
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        {verificationPopup1 && (
                            <div className="App">
                                <button>Turn Off APMS</button>
                                <div className="modal-overlay">
                                    <div className="modal-content">
                                        <img src={alert} alt="Alert Icon" />
                                        <h2>Turn Off APMS?</h2>
                                        <p style={{ padding: '5px 0px' }}><span style={{ fontWeight: '800', fontSize: 15 }}>{selectedMarker.name} KVA</span></p>
                                        <p>
                                            Are you Sure to <strong style={{ fontWeight: 'bold' }}>Turn Off</strong> APMS
                                        </p>
                                        <p>
                                            <strong style={{ fontWeight: 'bold', fontSize: 30, color: 'red' }}>
                                                Y
                                            </strong>
                                            <strong style={{ fontSize: 20, marginLeft: -5 }}>
                                                es
                                            </strong>
                                            <strong style={{ fontSize: 25 }}>
                                                /
                                            </strong>
                                            <strong style={{ fontWeight: 'bold', fontSize: 30, color: 'green' }}>
                                                N
                                            </strong>
                                            <strong style={{ fontSize: 20, marginLeft: 0 }}>
                                                o
                                            </strong>
                                        </p>
                                        <>
                                            <p style={{ marginLeft: -250, marginBottom: -2 }}>Reason</p>
                                            <Select
                                                style={{ backgroundColor: '#f3f4f6', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: 40 }}
                                                onChange={handleReason}
                                                displayEmpty
                                                fullWidth
                                                label="Reason"
                                                id="demo-simple-select"
                                                labelId="demo-simple-select-label"
                                            >
                                                <MenuItem value="MT">Maintenance - Work Permit</MenuItem>
                                                <MenuItem value="LL">Load Management</MenuItem>
                                                <MenuItem value="SA">Seasonal</MenuItem>
                                            </Select>
                                        </>
                                        <Button variant="contained" sx={{ width: '100%', marginTop: 2, backgroundColor: 'red' }}
                                            component="label" type='submit' onClick={handleSubmitTurnOff} disabled={reason ? false : true}
                                        >Turn Off</Button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                            open={viewBackdrop}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </div>
                </div>
            </MapContext.Provider>
        </div>
    ) : <></>;
}

export default React.memo(Map);